<template>
  <div class="dashboard-root" :class="themeClass">
    <div class="ambient" aria-hidden="true"></div>

    <header class="dash-header">
      <div class="brand" @click="$emit('home')" title="Inicio">
        <img src="@/assets/logogruas.png" alt="GM" class="logo" />
        <div class="brand-text">
          <h1>Panel Maestro</h1>
          <span class="brand-sub">Centro de Control · Grúas Monterrey</span>
        </div>
      </div>

      <div class="header-right">
        <div class="clock">
          <span class="clock-time">{{ clock.time }}</span>
          <span class="clock-date">{{ clock.date }}</span>
        </div>

        <div class="status-cluster">
          <span class="ws-pill" :class="wsClassOps"><span class="ws-dot"></span>Ops · {{ wsOps.status }}</span>
          <span class="ws-pill" :class="wsClassAcc"><span class="ws-dot"></span>Acc · {{ wsAcc.status }}</span>
        </div>

        <button
          class="theme-toggle"
          type="button"
          @click="toggleTheme"
          :title="isDark ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'"
        >
          <svg v-if="isDark" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <circle cx="12" cy="12" r="4"/>
            <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41"/>
          </svg>
          <svg v-else viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
          </svg>
        </button>
      </div>
    </header>

    <nav class="tabs">
      <button
        v-for="t in tabs"
        :key="t.key"
        :class="['tab', { active: t.key===activeTab }]"
        @click="activeTab=t.key"
      >
        <svg class="tab-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <template v-if="t.key==='operations'"><path d="M3 12h4l3 8 4-16 3 8h4"/></template>
          <template v-else-if="t.key==='accounting'"><rect x="2" y="5" width="20" height="14" rx="2"/><path d="M2 10h20"/></template>
          <template v-else-if="t.key==='maintenance'"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94z"/></template>
          <template v-else-if="t.key==='rrhh'"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></template>
          <template v-else-if="t.key==='estadistico'"><path d="M3 3v18h18"/><rect x="7" y="11" width="3" height="7"/><rect x="12" y="7" width="3" height="11"/><rect x="17" y="14" width="3" height="4"/></template>
          <template v-else><path d="m3 11 18-5v12L3 14v-3z"/><path d="M11.6 16.8a3 3 0 1 1-5.8-1.6"/></template>
        </svg>
        <span>{{ t.label }}</span>
      </button>
    </nav>

    <!-- OPERATIONS TAB -->
    <section v-if="activeTab==='operations'" :key="'ops-' + themeClass" class="tab-body">
      <div class="controls">
        <label>Fecha: <input type="date" v-model="opsDate" @change="fetchOperations" /></label>
        <label>Mes: <input type="month" v-model="opsMonth" @change="fetchOpsMonthly" /></label>
        <label>Año: <input type="number" v-model.number="opsYear" @change="fetchOperationsMonthly" style="width:90px" /></label>
      </div>

      <div class="hero-strip">
        <div class="hero-tile">
          <span class="hero-label">Unidades activas</span>
          <span class="hero-value">{{ ops.activeUnits.length }}</span>
        </div>
        <div class="hero-tile">
          <span class="hero-label">OT del día</span>
          <span class="hero-value">{{ opsTotalOrders }}</span>
        </div>
        <div class="hero-tile">
          <span class="hero-label">Clientes</span>
          <span class="hero-value">{{ ops.ordersPerClient.length }}</span>
        </div>
        <div class="hero-tile">
          <span class="hero-label">Sucursales</span>
          <span class="hero-value">{{ ops.sucursalCount.length }}</span>
        </div>
      </div>

        <div class="masonry">
        <StatCard title="Órdenes por cliente (top 5)">
              <v-chart :option="ordersPerClientPieOption" autoresize style="height:220px" />
  <ul class="legend-wrap">
    <li v-for="it in ordersPerClientLegend" :key="it.name">
      <span class="swatch" :style="{ background: it.color }"></span>
      <span class="legend-name">{{ it.name }}</span>
      <span class="legend-val">({{ it.pct }}%)</span>
    </li>
  </ul>

          <ol class="list">
  <li v-for="row in opsTopClients.top" :key="row.client_id">
    <span class="name">{{ row.client_name_ph || '—' }}</span>
    <span class="right">{{ row.orders }} <small class="muted">OT</small></span>
  </li>
  <li v-if="opsTopClients.others > 0">
    <span class="name">Otros</span>
    <span class="right">{{ opsTopClients.others }} <small class="muted">OT</small></span>
  </li>
  <li v-if="!ops.ordersPerClient.length" class="muted">Sin datos</li>
</ol>
        </StatCard>
<!-- OTs por cliente (pastel) -->
<!-- <StatCard title="OTs por cliente (pastel)">
  <v-chart :option="ordersPerClientPieOption" autoresize style="height:220px" />
  <ul class="legend-wrap">
    <li v-for="it in ordersPerClientLegend" :key="it.name">
      <span class="swatch" :style="{ background: it.color }"></span>
      <span class="legend-name">{{ it.name }}</span>
      <span class="legend-val">{{ it.value }} ({{ it.pct }}%)</span>
    </li>
  </ul>
</StatCard> -->

        <StatCard title="Unidades activas ahora">
          <div class="table-wrap scroll-rows-15">
            <table>
              <thead>
                <tr><th>Unidad</th><th>Operador</th><th>OT</th><th>Inicio</th></tr>
              </thead>
              <tbody>
                <tr v-for="(u, idx) in ops.activeUnits" :key="idx">
                  <td>{{ u.unit_short_id }}</td>
                  <td>{{ u.operator_ph }} {{ u.operator_last_ph }}</td>
                  <td>{{ u.note_number }}</td>
                  <td>{{ fmtDT(u.start_time_ph) }}</td>
                </tr>
                <tr v-if="!ops.activeUnits.length"><td colspan="4" class="muted">Sin activos</td></tr>
              </tbody>
            </table>
          </div>
        </StatCard>

        <StatCard title="Frecuencia por tipo (día)">
          <v-chart :option="typeFreqOption" autoresize style="height:220px" />
        </StatCard>

<!-- OTs por sucursal (día) — if you have this pie -->
<StatCard title="OTs por sucursal (día)">
  <v-chart :option="sucursalCountPieOption" autoresize style="height:220px" />
  <ul class="legend-wrap">
    <li v-for="it in sucursalCountLegend" :key="it.name">
      <span class="swatch" :style="{ background: it.color }"></span>
      <span class="legend-name">{{ it.name }}</span>
      <span class="legend-val">{{ it.value }} ({{ it.pct }}%)</span>
    </li>
  </ul>
</StatCard>

<StatCard title="Subtotal por sucursal (día)">
  <v-chart :option="sucursalSubtotalBarOption" autoresize style="height:220px" />
  <ul class="legend-wrap">
    <li v-for="item in sucursalLegend" :key="item.name">
      <span class="swatch" :style="{ background: item.color }"></span>
      <span class="legend-name">{{ item.name }}</span>
    </li>
  </ul>
</StatCard>

<StatCard title="OTs por día (mes)">
  <v-chart :option="otDailyCountOption" autoresize style="height:220px" />
</StatCard>

<StatCard title="Subtotal por día (mes)">
  <v-chart :option="subtotalDailySumOption" autoresize style="height:220px" />
</StatCard>

<StatCard title="Servicios AXA por día (mes)">
  <div class="kpis">
    <div class="kpi"><div class="kpi-label">Aceptados</div><div class="kpi-value">{{ ops.insurerTotals.accepted || 0 }}</div></div>
    <div class="kpi"><div class="kpi-label">Timeouts</div><div class="kpi-value">{{ ops.insurerTotals.timed_out || 0 }}</div></div>
    <div class="kpi"><div class="kpi-label">Con error</div><div class="kpi-value">{{ ops.insurerTotals.errored || 0 }}</div></div>
    <div class="kpi"><div class="kpi-label">Total</div><div class="kpi-value">{{ ops.insurerTotals.total || 0 }}</div></div>
  </div>
  <v-chart :option="insurerDailyOption" autoresize style="height:220px" />
</StatCard>


<StatCard title="OTs por mes (año)">
  <v-chart :option="opsMonthlyCountOption" autoresize style="height:220px" />
</StatCard>

<StatCard title="Subtotal por mes (año)">
  <v-chart :option="opsMonthlySubtotalOption" autoresize style="height:220px" />
</StatCard>

      </div>
    </section>

    <!-- ACCOUNTING TAB -->
    <section v-else-if="activeTab==='accounting'" :key="'acc-' + themeClass" class="tab-body">
      <div class="controls">
        <label>Fecha: <input type="date" v-model="accDate" @change="fetchAccounting" /></label>
        <label>Tipo de transacción: <input type="number" v-model.number="txType" @change="fetchAccounting" /></label>
      </div>

      <div class="hero-strip">
        <div class="hero-tile">
          <span class="hero-label">Facturas hoy</span>
          <span class="hero-value">{{ invSummarySplit.count }}</span>
        </div>
        <div class="hero-tile">
          <span class="hero-label">Total de cartera</span>
          <span class="hero-value">{{ money(acc.totalCredit) }}</span>
        </div>
        <div class="hero-tile">
          <span class="hero-label">OT sin factura</span>
          <span class="hero-value">{{ acc.uninvoiced }}</span>
        </div>
        <div class="hero-tile">
          <span class="hero-label">Pagos hoy</span>
          <span class="hero-value">{{ acc.payments.summary.count || 0 }}</span>
        </div>
      </div>

      <div class="masonry">
        <StatCard title="Facturas emitidas (hoy)">
          <div class="kpis">
  <div class="kpi"><div class="kpi-label">#</div><div class="kpi-value">{{ invSummarySplit.count }}</div></div>
  <div class="kpi"><div class="kpi-label">Monto crédito</div><div class="kpi-value">{{ money(invSummarySplit.total_amount_credit) }}</div></div>
  <div class="kpi"><div class="kpi-label">Monto contado</div><div class="kpi-value">{{ money(invSummarySplit.total_amount_contado) }}</div></div>
  <div class="kpi"><div class="kpi-label">Saldo</div><div class="kpi-value">{{ money(invSummarySplit.total_balance) }}</div></div>
</div>
          <div class="table-wrap scroll-rows-15">
            <table>
              <thead><tr><th>Ident</th><th>Serie</th><th>#</th><th>Tipo</th><th>Fecha</th><th>Monto</th><th>Saldo</th><th>Cancelada</th></tr></thead>
              <tbody>
                <tr v-for="inv in acc.invoices.results" :key="inv.id">
                  <td>{{ inv.invoice_ident }}</td>
                  <td>{{ inv.invoice_series }}</td>
                  <td class="num">{{ inv.invoice_number }}</td>
                  <td>{{ inv.invoice_type }}</td>
                  <td>{{ fmtDT(inv.date_issued) }}</td>
                  <td class="num">{{ money(inv.amount) }}</td>
                  <td class="num">{{ money(inv.balance) }}</td>
                  <td>{{ inv.is_cancelled ? 'Sí' : 'No' }}</td>
                </tr>
                <tr v-if="!acc.invoices.results.length"><td colspan="8" class="muted">Sin facturas</td></tr>
              </tbody>
            </table>
          </div>
        </StatCard>

        <StatCard :title="'Pagos recibidos (tipo ' + txType + ')'">
          <div class="kpis">
            <div class="kpi"><div class="kpi-label">#</div><div class="kpi-value">{{ acc.payments.summary.count || 0 }}</div></div>
            <div class="kpi"><div class="kpi-label">Monto</div><div class="kpi-value">{{ money(acc.payments.summary.total_amount) }}</div></div>
          </div>
          <div class="table-wrap scroll-rows-15">
            <table>
              <thead><tr><th>Ident</th><th>Referencia</th><th>Banco</th><th>Método</th><th>Fecha</th><th>Monto</th></tr></thead>
              <tbody>
                <tr v-for="tx in acc.payments.results" :key="tx.id">
                  <td>{{ tx.transaction_ident }}</td>
                  <td>{{ tx.reference }}</td>
                  <td>{{ tx.bank }}</td>
                  <td>{{ tx.payment_method }}</td>
                  <td>{{ fmtDT(tx.transaction_date) }}</td>
                  <td class="num">{{ money(tx.amount) }}</td>
                </tr>
                <tr v-if="!acc.payments.results.length"><td colspan="6" class="muted">Sin pagos</td></tr>
              </tbody>
            </table>
          </div>
        </StatCard>

        <!-- Redundant: now shown in the accounting KPI hero strip ("OT sin factura").
        <StatCard title="OT sin factura">
          <div class="single-kpi">{{ acc.uninvoiced }}</div>
        </StatCard>
        -->

        <StatCard title="Pendiente por facturar por cliente">
  <v-chart :option="pendingBillingByClientOption" autoresize style="height:220px" />
  <ul class="legend-wrap">
    <li v-for="r in pendingBillingByClient" :key="r.client_name">
      <span class="swatch" :style="{ background: r.client_name === 'Otros' ? '#9AA1AC' : colorFor(r.client_name) }"></span>
      <span class="legend-name">{{ r.client_name }}</span>
      <span class="legend-val">{{ money(r.amount) }}</span>
    </li>
  </ul>
</StatCard>

        <!-- KPI: Total Crédito -->
        <!-- Redundant: now shown in the accounting KPI hero strip ("Total de cartera").
<StatCard title="Total de Cartera">
  <div class="single-kpi">{{ money(acc.totalCredit) }}</div>
</StatCard>
        -->

<!-- Bar: Balance por cliente (Top N + Otros) -->
<StatCard title="Saldo por cliente (Top)">
  <v-chart :option="balPerClientBarOption" autoresize style="height:220px" />
  <ul class="legend-wrap">
    <li v-for="it in balPerClientLegend" :key="it.name">
      <span class="swatch" :style="{ background: it.color }"></span>
      <span class="legend-name">{{ it.name }}</span>
      <span class="legend-val">{{ money(it.value) }} ({{ it.pct }}%)</span>
    </li>
  </ul>
</StatCard>


<StatCard title="Serie histórica de crédito (mes)">
  <label>
    Mes:
    <input type="month" v-model="creditMonth" @change="fetchCreditTimeseries" />
  </label>
  <v-chart :option="accCreditTimeseriesOption" autoresize style="height:260px" />
</StatCard>


<StatCard title="Pendiente por facturar por dia">
  <label>
    Mes:
    <input type="month" v-model="uninvoicedMonth" @change="fetchUninvoicedSubtotalDaily" />
  </label>
  <v-chart :option="accUninvoicedSubtotalDailyOption" autoresize style="height:260px" />
</StatCard>

      </div>
    </section>

    <!-- UNIDADES TAB -->
<section v-else-if="activeTab==='maintenance'" :key="'maint-' + themeClass" class="tab-body">
  <div class="subtabs" role="tablist">
    <button
      v-for="s in maintSections"
      :key="s.key"
      role="tab"
      :aria-selected="s.key===maintSection"
      :class="['subtab', { active: s.key===maintSection }]"
      @click="maintSection = s.key"
    >{{ s.label }}</button>
  </div>

  <template v-if="maintSection==='graficas'">
  <div class="controls">
    <label>Fecha: <input type="date" v-model="maintDate" @change="fetchMaintenance" /></label>
  </div>

  <div class="hero-strip">
    <div class="hero-tile">
      <span class="hero-label">Unidades</span>
      <span class="hero-value">{{ maint.perUnitCount.length }}</span>
    </div>
    <div class="hero-tile">
      <span class="hero-label">Monto total</span>
      <span class="hero-value">{{ money(maintTotalMoney) }}</span>
    </div>
    <div class="hero-tile">
      <span class="hero-label">KM totales</span>
      <span class="hero-value">{{ maintTotalKm }}</span>
    </div>
    <div class="hero-tile">
      <span class="hero-label">Grupos</span>
      <span class="hero-value">{{ maint.byPrefix.length }}</span>
    </div>
  </div>

  <div class="masonry">
    <!-- Asignaciones por unidad -->
    <StatCard title="Asignaciones por unidad (OTs)">
      <v-chart :option="countPerUnitOption" autoresize style="height:220px" />
      <ul class="legend-wrap">
        <li v-for="r in maint.perUnitCount" :key="r.unit_short_id">
          <span class="swatch" :style="{ background: colorFor(r.unit_short_id) }"></span>
          <span class="legend-name">{{ r.unit_short_id }}</span>
          <span class="legend-val">{{ r.count }} OT</span>
        </li>
      </ul>

      <div class="table-wrap scroll-rows-15">
        <table>
          <thead><tr><th>Unidad</th><th class="num">OTs</th></tr></thead>
          <tbody>
            <tr v-for="r in maint.perUnitCount" :key="r.unit_short_id">
              <td>{{ r.unit_short_id }}</td>
              <td class="num">{{ r.count }}</td>
            </tr>
            <tr v-if="!maint.perUnitCount.length"><td colspan="2" class="muted">Sin datos</td></tr>
          </tbody>
        </table>
      </div>
    </StatCard>


    <!-- Monto por unidad -->
    <StatCard title="Monto por unidad (subtotal de OT)">
      <v-chart :option="moneyPerUnitOption" autoresize style="height:220px" />
      <ul class="legend-wrap">
        <li v-for="r in maint.perUnitMoney" :key="r.unit_short_id">
          <span class="swatch" :style="{ background: colorFor(r.unit_short_id) }"></span>
          <span class="legend-name">{{ r.unit_short_id }}</span>
          <span class="legend-val">{{ money(r.amount) }}</span>
        </li>
      </ul>

      <div class="table-wrap scroll-rows-15">
        <table>
          <thead><tr><th>Unidad</th><th class="num">Monto</th></tr></thead>
          <tbody>
            <tr v-for="r in maint.perUnitMoney" :key="r.unit_short_id">
              <td>{{ r.unit_short_id }}</td>
              <td class="num">{{ money(r.amount) }}</td>
            </tr>
            <tr v-if="!maint.perUnitMoney.length"><td colspan="2" class="muted">Sin datos</td></tr>
          </tbody>
        </table>
      </div>
    </StatCard>

    <!-- KM por unidad -->
    <StatCard title="KM recorridos por unidad">
      <v-chart :option="kmPerUnitOption" autoresize style="height:220px" />
      <ul class="legend-wrap">
        <li v-for="r in maint.perUnitKm" :key="r.unit_short_id">
          <span class="swatch" :style="{ background: colorFor(r.unit_short_id) }"></span>
          <span class="legend-name">{{ r.unit_short_id }}</span>
          <span class="legend-val">{{ r.km }} km</span>
        </li>
      </ul>

      <div class="table-wrap scroll-rows-15">
        <table>
          <thead><tr><th>Unidad</th><th class="num">KM</th></tr></thead>
          <tbody>
            <tr v-for="r in maint.perUnitKm" :key="r.unit_short_id">
              <td>{{ r.unit_short_id }}</td>
              <td class="num">{{ r.km }}</td>
            </tr>
            <tr v-if="!maint.perUnitKm.length"><td colspan="2" class="muted">Sin datos</td></tr>
          </tbody>
        </table>
      </div>
    </StatCard>

    <!-- Prefijos -->
    <StatCard title="OTs por grupo (210/230/240/640)">
      <v-chart :option="otByPrefixOption" autoresize style="height:220px" />
      <ul class="legend-wrap">
        <li v-for="r in maint.byPrefix" :key="r.prefix">
          <span class="swatch" :style="{ background: colorFor(r.prefix) }"></span>
          <span class="legend-name">{{ r.prefix }}</span>
          <span class="legend-val">{{ r.count }} OT</span>
        </li>
      </ul>
    </StatCard>
  </div>
  </template>

  <template v-else>
  <div class="controls">
    <label>Desde: <input type="date" v-model="unitStatsStart" @change="fetchUnitStats" /></label>
    <label>Hasta: <input type="date" v-model="unitStatsEnd" @change="fetchUnitStats" /></label>
    <label>
      Ordenar por:
      <select v-model="unitStatsSort" class="unit-sort">
        <option value="services">Servicios</option>
        <option value="money">Monto</option>
        <option value="km">Kilómetros</option>
        <option value="unit">Número de unidad</option>
      </select>
    </label>
    <label class="unit-toggle">
      <input type="checkbox" v-model="unitStatsOnlyActive" />
      Solo unidades con actividad
    </label>
    <label class="unit-toggle">
      <input type="checkbox" v-model="unitStatsOnlyIdle" />
      Solo unidades sin actividad
    </label>
    <span v-if="unitStatsLoading" class="muted">Cargando…</span>
  </div>

  <div class="hero-strip">
    <div class="hero-tile">
      <span class="hero-label">Unidades con actividad</span>
      <span class="hero-value">{{ fmtInt(unitStatsTotals.units) }}</span>
    </div>
    <div class="hero-tile">
      <span class="hero-label">Servicios</span>
      <span class="hero-value">{{ fmtInt(unitStatsTotals.services) }}</span>
    </div>
    <div class="hero-tile">
      <span class="hero-label">Monto total</span>
      <span class="hero-value">{{ money(unitStatsTotals.money) }}</span>
    </div>
    <div class="hero-tile">
      <span class="hero-label">KM totales</span>
      <span class="hero-value">{{ fmtInt(unitStatsTotals.km) }}</span>
    </div>
  </div>

  <div class="unit-pills" role="tablist">
    <button
      v-for="c in UNIT_CATEGORY_COLUMNS"
      :key="c.key"
      role="tab"
      :aria-selected="c.key===unitStatsCategory"
      :class="['unit-pill', `unit-pill--${c.key}`, { active: c.key===unitStatsCategory }]"
      @click="unitStatsCategory = c.key"
    >
      <span class="unit-pill__dot"></span>
      {{ c.title }}
      <span class="unit-pill__count">{{ unitStatsCounts[c.key] }}</span>
    </button>
  </div>

  <div class="unit-grid" :class="`unit-grid--${unitStatsCategory}`">
    <article v-for="u in unitStatsVisible" :key="u.id" class="unit-stat-card">
      <div class="unit-stat-card__top">
        <span class="unit-stat-card__id">{{ u.unit_short_id }}</span>
        <span v-if="u.unit_category" class="unit-stat-card__cat">{{ u.unit_category }}</span>
      </div>
      <div class="unit-stat-card__metrics">
        <div class="unit-metric">
          <span class="unit-metric__label">Servicios</span>
          <span class="unit-metric__value">{{ fmtInt(u.services) }}</span>
        </div>
        <div class="unit-metric">
          <span class="unit-metric__label">Monto</span>
          <span class="unit-metric__value">{{ fmtMoney0(u.money) }}</span>
        </div>
        <div class="unit-metric">
          <span class="unit-metric__label">KM</span>
          <span class="unit-metric__value">{{ fmtInt(u.km) }}</span>
        </div>
      </div>
      <div class="unit-stat-card__last" :class="{ 'unit-stat-card__last--alert': isUnitStale(u) }">
        <svg viewBox="0 0 24 24" width="13" height="13" aria-hidden="true"><path d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2Zm4.2 14.2L11 13.4V6h1.8v6.4l4.4 2.6Z" fill="currentColor"/></svg>
        <span v-if="u.last_service_at">
          Último servicio {{ elapsedLabel(u.last_service_at) }} · {{ fmtDateTime(u.last_service_at) }}
        </span>
        <span v-else>Sin servicios registrados</span>
      </div>
    </article>

    <div v-if="!unitStatsVisible.length" class="unit-grid__empty">Sin unidades</div>
  </div>
  </template>
</section>
    <!-- RRHH TAB -->
<section v-else-if="activeTab==='rrhh'" :key="'rrhh-' + themeClass" class="tab-body">
  <div class="controls">
    <label>Fecha: <input type="date" v-model="rrhhDate" @change="fetchRRHH" /></label>
    <label>
  Mes:
  <input type="month" v-model="rrhhMonthYear" @change="fetchRRHHMonthly" />
</label>
  </div>

  <div class="hero-strip">
    <div class="hero-tile">
      <span class="hero-label">Capturistas</span>
      <span class="hero-value">{{ rrhh.perClerk.length }}</span>
    </div>
    <div class="hero-tile">
      <span class="hero-label">OT hoy</span>
      <span class="hero-value">{{ rrhhTotalToday }}</span>
    </div>
    <div class="hero-tile">
      <span class="hero-label">OT del mes</span>
      <span class="hero-value">{{ rrhhMonthTotal }}</span>
    </div>
    <div class="hero-tile">
      <span class="hero-label">Seleccionados</span>
      <span class="hero-value">{{ rrhhSelectedClerks.length }}</span>
    </div>
  </div>

  <StatCard class="rrhh-wide-card" title="OTs por capturista (mensual)">
      <div class="rrhh-monthly-layout">
        <!-- LEFT: table = selection UI -->
        <div class="rrhh-monthly-table">
          <div class="table-header-actions">
            <button type="button" class="link-button" @click="toggleSelectAllClerks">
              {{ allClerksSelected ? 'Quitar selección' : 'Seleccionar todos' }}
            </button>
          </div>
          <div class="table-wrap scroll-rows-15">
            <table>
              <thead>
                <tr>
                  <th>Capturista</th>
                  <th class="num">Total OTs</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="s in rrhhMonthlyTotalsSorted"
                  :key="s.clerk_id"
                  :class="['clickable-row', { 'row-selected': rrhhSelectedClerks.includes(s.clerk_id) }]"
                  @click="toggleClerkRow(s.clerk_id)"
                >
                  <td>{{ s.clerk_name }}</td>
                  <td class="num">{{ s.total }}</td>
                </tr>
                <tr v-if="!rrhhMonthlyTotalsSorted.length">
                  <td colspan="2" class="muted">Sin datos</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- RIGHT: chart -->
        <div class="rrhh-monthly-chart">
          <div class="rrhh-matrix-wrap">
            <table class="rrhh-matrix-table">
              <thead>
                <tr>
                  <th class="sticky-col">Capturista</th>
                  <th v-for="day in rrhhMonthlyDays" :key="`h-day-${day}`" class="num">
                    {{ day }}
                  </th>
                  <th class="num">Total</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="row in rrhhMonthlyTotalsSorted" :key="`m-${row.clerk_id}`">
                  <td class="sticky-col">
                    <span class="clerk-name">
                      <span class="clerk-dot" :style="{ background: colorFor(row.clerk_name) }"></span>
                      {{ row.clerk_name }}
                    </span>
                  </td>
                  <td
                    v-for="(val, idx) in (row.daily || [])"
                    :key="`r-${row.clerk_id}-d-${idx}`"
                    class="num day-cell"
                    :style="rrhhMatrixCellStyle(val)"
                  >
                    {{ Number(val || 0) }}
                  </td>
                  <td class="num total-cell">{{ Number(row.total || 0) }}</td>
                </tr>
                <tr v-if="!rrhhMonthlyTotalsSorted.length">
                  <td :colspan="rrhhMonthlyDays.length + 2" class="muted">Sin datos</td>
                </tr>
              </tbody>
            </table>
          </div>
          <v-chart :option="rrhhMonthlyChartOption" autoresize
    style="width:100%;height:320px;" />
        </div>
      </div>
    </StatCard>

  <div class="masonry">
    <StatCard title="OTs por capturista (hoy)">
      <v-chart :option="rrhhPerClerkOption" autoresize style="height:220px" />
      <!-- wrapped mapping (acts like legend) -->
      <ul class="legend-wrap">
        <li v-for="r in rrhh.perClerk" :key="r.clerk_id">
          <span
            class="swatch"
            :style="{
              background:
                r.count === Math.max(...rrhh.perClerk.map(x => x.count)) ? '#22c55e' :
                r.count === Math.min(...rrhh.perClerk.map(x => x.count)) ? '#ef4444' : '#3b82f6'
            }"
          ></span>
          <span class="legend-name">{{ r.clerk_name }}</span>
          <span class="legend-val">{{ r.count }} OT</span>
        </li>
      </ul>
    </StatCard>

    <StatCard title="OTs por capturista (hoy) - Detalle">
      <div class="table-wrap scroll-rows-15">
        <table>
          <thead>
            <tr><th>Capturista</th><th class="num">OTs</th></tr>
          </thead>
          <tbody>
            <tr
              v-for="r in rrhh.perClerk"
              :key="r.clerk_id"
              :class="{
                best: bestWorstIds.best === r.clerk_id,
                worst: bestWorstIds.worst === r.clerk_id
              }"
            >
              <td>{{ r.clerk_name }}</td>
              <td class="num">{{ r.count }}</td>
            </tr>
            <tr v-if="!rrhh.perClerk.length"><td colspan="2" class="muted">Sin datos</td></tr>
          </tbody>
        </table>
      </div>
    </StatCard>

    
  </div>
</section>
<section v-else-if="activeTab==='estadistico'" :key="'est-' + themeClass" class="tab-body">
  <div class="controls">
    <label>
      Mes:
      <input type="month" v-model="estadisticoMonth" @change="fetchEstadisticoClientes" />
    </label>
  </div>

  <div class="hero-strip">
    <div class="hero-tile">
      <span class="hero-label">Clientes</span>
      <span class="hero-value">{{ estadistico.countRows.length }}</span>
    </div>
    <div class="hero-tile">
      <span class="hero-label">Servicios (mes)</span>
      <span class="hero-value">{{ estadistico.countGrandTotal }}</span>
    </div>
    <div class="hero-tile">
      <span class="hero-label">Ingresos (mes)</span>
      <span class="hero-value">{{ money(estadistico.subtotalGrandTotal) }}</span>
    </div>
    <div class="hero-tile">
      <span class="hero-label">Días</span>
      <span class="hero-value">{{ estadistico.days.length }}</span>
    </div>
  </div>

  <div class="estadistico-stack">
    <StatCard :title="`Servicios por cliente (${estadisticoYear})`">
      <div class="estadistico-table-wrap">
        <table class="estadistico-table">
          <thead>
            <tr>
              <th class="sticky-col">Cliente</th>
              <th v-for="label in estadisticoMonthLabels" :key="`y-count-h-${label}`" class="num">{{ label }}</th>
              <th class="num">Total</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in estadisticoYearly.countRows" :key="`y-count-r-${row.client}`">
              <td class="sticky-col">{{ row.client }}</td>
              <td v-for="(v, idx) in row.monthly" :key="`y-count-v-${row.client}-${idx}`" class="num">{{ v }}</td>
              <td class="num total-cell">{{ row.total }}</td>
            </tr>
            <tr v-if="estadisticoYearly.countRows.length">
              <td class="sticky-col total-label">Total Global</td>
              <td v-for="(v, idx) in estadisticoYearly.countTotalMonthly" :key="`y-count-total-m-${idx}`" class="num total-cell">{{ v }}</td>
              <td class="num total-cell">{{ estadisticoYearly.countGrandTotal }}</td>
            </tr>
            <tr v-if="!estadisticoYearly.countRows.length">
              <td :colspan="estadisticoMonthLabels.length + 2" class="muted">Sin datos</td>
            </tr>
          </tbody>
        </table>
      </div>
    </StatCard>

    <StatCard :title="`Ingresos por cliente (${estadisticoYear})`">
      <div class="estadistico-table-wrap">
        <table class="estadistico-table">
          <thead>
            <tr>
              <th class="sticky-col">Cliente</th>
              <th v-for="label in estadisticoMonthLabels" :key="`y-subtotal-h-${label}`" class="num">{{ label }}</th>
              <th class="num">Total</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in estadisticoYearly.subtotalRows" :key="`y-subtotal-r-${row.client}`">
              <td class="sticky-col">{{ row.client }}</td>
              <td v-for="(v, idx) in row.monthly" :key="`y-subtotal-v-${row.client}-${idx}`" class="num">{{ money(v) }}</td>
              <td class="num total-cell">{{ money(row.total) }}</td>
            </tr>
            <tr v-if="estadisticoYearly.subtotalRows.length">
              <td class="sticky-col total-label">Total Global</td>
              <td v-for="(v, idx) in estadisticoYearly.subtotalTotalMonthly" :key="`y-subtotal-total-m-${idx}`" class="num total-cell">{{ money(v) }}</td>
              <td class="num total-cell">{{ money(estadisticoYearly.subtotalGrandTotal) }}</td>
            </tr>
            <tr v-if="!estadisticoYearly.subtotalRows.length">
              <td :colspan="estadisticoMonthLabels.length + 2" class="muted">Sin datos</td>
            </tr>
          </tbody>
        </table>
      </div>
    </StatCard>

    <StatCard title="Servicios por cliente (mensual)">
      <div class="estadistico-table-wrap">
        <table class="estadistico-table">
          <thead>
            <tr>
              <th class="sticky-col">Cliente</th>
              <th v-for="day in estadistico.days" :key="`count-h-${day}`" class="num">{{ day }}</th>
              <th class="num">Total</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in estadistico.countRows" :key="`count-r-${row.client}`">
              <td class="sticky-col">{{ row.client }}</td>
              <td v-for="(v, idx) in row.daily" :key="`count-v-${row.client}-${idx}`" class="num">{{ v }}</td>
              <td class="num total-cell">{{ row.total }}</td>
            </tr>
            <tr v-if="estadistico.countRows.length">
              <td class="sticky-col total-label">Total Global</td>
              <td v-for="(v, idx) in estadistico.countTotalDaily" :key="`count-total-d-${idx}`" class="num total-cell">{{ v }}</td>
              <td class="num total-cell">{{ estadistico.countGrandTotal }}</td>
            </tr>
            <tr v-if="!estadistico.countRows.length">
              <td :colspan="estadistico.days.length + 2" class="muted">Sin datos</td>
            </tr>
          </tbody>
        </table>
      </div>
    </StatCard>

    <StatCard title="Ingresos por cliente (mensual)">
      <div class="estadistico-table-wrap">
        <table class="estadistico-table">
          <thead>
            <tr>
              <th class="sticky-col">Cliente</th>
              <th v-for="day in estadistico.days" :key="`subtotal-h-${day}`" class="num">{{ day }}</th>
              <th class="num">Total</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in estadistico.subtotalRows" :key="`subtotal-r-${row.client}`">
              <td class="sticky-col">{{ row.client }}</td>
              <td v-for="(v, idx) in row.daily" :key="`subtotal-v-${row.client}-${idx}`" class="num">{{ money(v) }}</td>
              <td class="num total-cell">{{ money(row.total) }}</td>
            </tr>
            <tr v-if="estadistico.subtotalRows.length">
              <td class="sticky-col total-label">Total Global</td>
              <td v-for="(v, idx) in estadistico.subtotalTotalDaily" :key="`subtotal-total-d-${idx}`" class="num total-cell">{{ money(v) }}</td>
              <td class="num total-cell">{{ money(estadistico.subtotalGrandTotal) }}</td>
            </tr>
            <tr v-if="!estadistico.subtotalRows.length">
              <td :colspan="estadistico.days.length + 2" class="muted">Sin datos</td>
            </tr>
          </tbody>
        </table>
      </div>
    </StatCard>
  </div>
</section>

<!-- PUBLICIDAD (Google Ads) TAB -->
<section v-else-if="activeTab==='publicidad'" :key="'ads-' + themeClass" class="tab-body">
  <div class="controls ads-controls">
    <label>Desde: <input type="date" v-model="adsStart" :max="adsEnd" @change="onAdsRangeChange" /></label>
    <label>Hasta: <input type="date" v-model="adsEnd" :min="adsStart" @change="onAdsRangeChange" /></label>
    <div class="ads-presets">
      <button type="button" :class="['ads-preset', { active: adsPreset==='7d' }]" @click="setAdsPreset('7d')">Últimos 7 días</button>
      <button type="button" :class="['ads-preset', { active: adsPreset==='30d' }]" @click="setAdsPreset('30d')">Últimos 30 días</button>
      <button type="button" :class="['ads-preset', { active: adsPreset==='month' }]" @click="setAdsPreset('month')">Este mes</button>
    </div>
  </div>

  <div class="ads-group">
    <h3 class="ads-group-title"><span class="ads-group-bar"></span>Remolque</h3>
    <AdsCampaignCard
      v-for="c in adsCampaigns.remolque"
      :key="c.name"
      :title="c.title"
      :data="ads[c.name] ? ads[c.name].data : null"
      :loading="ads[c.name] ? ads[c.name].loading : true"
    />
    <StatCard class="ads-internal-card" title="Sistema · Servicios cerrados y Ganancia">
      <MetricSeriesBlock
        :metrics="adsInternalMetrics"
        :data="adsInternal.remolque ? adsInternal.remolque.data : null"
        :loading="adsInternal.remolque ? adsInternal.remolque.loading : true"
        :default-selected="['services_closed', 'ganancia']"
      />
    </StatCard>
  </div>

  <div class="ads-group">
    <h3 class="ads-group-title"><span class="ads-group-bar montacargas"></span>Montacargas</h3>
    <AdsCampaignCard
      v-for="c in adsCampaigns.montacargas"
      :key="c.name"
      :title="c.title"
      :data="ads[c.name] ? ads[c.name].data : null"
      :loading="ads[c.name] ? ads[c.name].loading : true"
    />
    <StatCard class="ads-internal-card" title="Sistema · Servicios cerrados y Ganancia">
      <MetricSeriesBlock
        :metrics="adsInternalMetrics"
        :data="adsInternal.montacargas ? adsInternal.montacargas.data : null"
        :loading="adsInternal.montacargas ? adsInternal.montacargas.loading : true"
        :default-selected="['services_closed', 'ganancia']"
      />
    </StatCard>
  </div>

  <StatCard
    class="ads-services-card"
    :title="`Servicios que califican (${adsServices.data ? adsServices.data.count || 0 : 0})`"
  >
    <div class="table-wrap ads-services-table scroll-rows-15">
      <table>
        <thead>
          <tr>
            <th>Cliente</th>
            <th class="num"># Nota</th>
            <th>Tipo</th>
            <th class="num">Total</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in (adsServices.data ? adsServices.data.results : [])" :key="row.note_ident || row.note_number">
            <td>{{ row.client_name }}</td>
            <td class="num">{{ row.note_number }}</td>
            <td>
              <span class="ads-type-chip" :class="row.category === 'Montacargas' ? 'mont' : 'remo'">{{ row.category }}</span>
            </td>
            <td class="num">{{ money(row.total) }}</td>
            <td class="num">
              <a
                v-if="row.note_ident"
                class="ads-open-btn"
                :href="adsNoteBaseUrl + row.note_ident"
                target="_blank"
                rel="noopener noreferrer"
              >
                Abrir
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 3h6v6"/><path d="M10 14 21 3"/><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/></svg>
              </a>
              <span v-else class="muted">—</span>
            </td>
          </tr>
          <tr v-if="adsServices.loading">
            <td colspan="5" class="muted">Cargando…</td>
          </tr>
          <tr v-else-if="!adsServices.data || !adsServices.data.results || !adsServices.data.results.length">
            <td colspan="5" class="muted">Sin servicios que califiquen en el periodo.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </StatCard>
</section>
  </div>
</template>

<script setup>
import { ref, reactive, computed, watch, onMounted, onUnmounted, provide } from 'vue'
import axios from 'axios'
import { THEME_KEY } from 'vue-echarts'
import StatCard from './primitives/StatCard.vue'
import AdsCampaignCard from './AdsCampaignCard.vue'
import MetricSeriesBlock from './MetricSeriesBlock.vue'
import { useDashboardWS } from '../composables/useDashboardWS'

const tabs = [
  { key: 'operations', label: 'Operaciones' },
  { key: 'accounting', label: 'Contabilidad' },
  { key: 'maintenance', label: 'Unidades' },
  { key: 'rrhh', label: 'RRHH' },
  { key: 'estadistico', label: 'Estadistico' },
  { key: 'publicidad', label: 'Publicidad' },
]
const activeTab = ref('operations')

const currentYear = new Date().getFullYear()
const opsYear = ref(currentYear)

const todayMonterrey = new Date().toLocaleString("en-US", { timeZone: "America/Monterrey" });
const local = new Date(todayMonterrey);
const todayISO = local.toLocaleDateString("en-CA").slice(0, 10);
const opsDate = ref(todayISO) 
const accDate = ref(todayISO)
const txType = ref(2)

const opsMonth = ref((opsDate.value || '').slice(0, 7) || new Date().toISOString().slice(0,7))

const ops = reactive({
  ordersPerClient: [],
  activeUnits: [],
  typeFrequency: [],
  sucursalCount: [],
  sucursalSubtotal: [],
  dailyCount: [],        // NEW
  dailySubtotal: [],      // NEW
  monthlyCount: [],      // NEW: [{month, count}]
  monthlySubtotal: [],
  insurerDaily: [],      // AXA: [{date, total, accepted, timed_out, errored, ...}]
  insurerTotals: {}      // AXA month totals
})

// add to acc state
const acc = reactive({
  invoices: { summary: {}, results: [] },
  payments: { summary: {}, results: [] },
  uninvoiced: 0,
  balPerClient: [],       // NEW
  totalCredit: 0          // NEW
})

// RRHH state
const rrhhDate = ref(opsDate.value)     // reuse Monterrey-local date you already compute
const rrhh = reactive({ perClerk: [] })
const rrhhMonthYear = ref(
  `${local.getFullYear()}-${String(local.getMonth() + 1).padStart(2,"0")}`
)
const rrhhMonthlyDays   = ref([])                    // [1,2,...]
const rrhhMonthlySeries = ref([])                    // [{clerk_id, clerk_name, daily[], total}]
const rrhhSelectedClerks = ref([])
const estadisticoMonth = ref(rrhhMonthYear.value)
const estadisticoMonthLabels = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic']
const estadisticoYear = computed(() => String(estadisticoMonth.value || '').slice(0, 4))
const estadistico = reactive({
  days: [],
  countRows: [],
  countTotalDaily: [],
  countGrandTotal: 0,
  subtotalRows: [],
  subtotalTotalDaily: [],
  subtotalGrandTotal: 0,
})
const estadisticoYearly = reactive({
  loadedYear: null,
  countRows: [],
  countTotalMonthly: [],
  countGrandTotal: 0,
  subtotalRows: [],
  subtotalTotalMonthly: [],
  subtotalGrandTotal: 0,
})

function apiBase() {
  const API = process.env.API_DIRECTORY || '';
  return `${API}`;
}

// palette (adjust if you want)
const PALETTE = [
  '#3b82f6','#10b981','#f59e0b','#ef4444','#8b5cf6',
  '#06b6d4','#84cc16','#f97316','#ec4899','#22c55e',
  '#64748b','#a855f7','#14b8a6','#eab308','#fb7185'
]

// stable color per name
function colorFor(name) {
  let h = 0; for (let i=0;i<name.length;i++) h = (h*31 + name.charCodeAt(i)) >>> 0
  return PALETTE[h % PALETTE.length]
}

// vertical fade for a 6-digit hex color -> ECharts linear gradient (visual only)
function barGradient(hex) {
  return {
    type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
    colorStops: [
      { offset: 0, color: hex },
      { offset: 1, color: hex + '4D' },
    ],
  }
}

// soft top-down fill for line charts (visual only)
function areaGradient(hex) {
  return {
    type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
    colorStops: [
      { offset: 0, color: hex + '59' },
      { offset: 1, color: hex + '03' },
    ],
  }
}

// rounded "column" styling shared by every bar chart (visual only)
const BAR_RADIUS = [6, 6, 0, 0]
const LINE_ACCENT = '#0ea5e9'

// shared modern line-series visuals (caller still supplies type/data/etc.)
function lineLook(hex) {
  return {
    smooth: 0.4,
    showSymbol: false,
    symbol: 'circle',
    symbolSize: 7,
    lineStyle: { color: hex, width: 2.6, cap: 'round' },
    itemStyle: { color: hex, borderColor: '#fff', borderWidth: 1.5 },
    areaStyle: { color: areaGradient(hex) },
    emphasis: { focus: 'series', scale: 1.3 },
  }
}

const fmtInt    = (v) => (Number(v) || 0).toLocaleString('es-MX')
const fmtMoney0 = (v) => (Number(v) || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN', maximumFractionDigits: 0 })

// peak marker + end-of-line label so key figures read without hovering (visual only)
function peakLastDecor(fmt) {
  return {
    endLabel: {
      show: true,
      formatter: (p) => fmt(p.value),
      fontWeight: 700,
      fontSize: 11,
      distance: 8,
    },
    markPoint: {
      symbol: 'circle',
      symbolSize: 9,
      itemStyle: { borderColor: '#fff', borderWidth: 2 },
      label: { show: true, position: 'top', distance: 6, fontWeight: 700, fontSize: 11, formatter: (p) => fmt(p.value) },
      data: [{ type: 'max', name: 'Máx' }],
    },
  }
}

// faint dashed average reference line (visual only)
function avgLineDecor(fmt) {
  return {
    markLine: {
      symbol: 'none',
      lineStyle: { type: 'dashed', color: 'rgba(148,163,184,0.65)', width: 1 },
      label: {
        formatter: (p) => `Prom. ${fmt(p.value)}`,
        position: 'insideEndTop',
        color: '#94a3b8',
        fontSize: 10.5,
      },
      data: [{ type: 'average' }],
    },
  }
}

function money(v){ const n = Number(v || 0); return n.toLocaleString('es-MX', { style:'currency', currency:'MXN' }) }
function fmtDT(v){ if(!v) return '—'; try { return new Date(v).toLocaleString('es-MX') } catch { return v } }

/* ───────────────────────── Theme (light / dark) ───────────────────────── */
const isDark = ref(true)
try {
  const saved = localStorage.getItem('masterDashTheme')
  if (saved) isDark.value = saved === 'dark'
} catch (e) { /* ignore */ }

const themeClass = computed(() => (isDark.value ? 'theme-dark' : 'theme-light'))

function toggleTheme() {
  isDark.value = !isDark.value
  try { localStorage.setItem('masterDashTheme', isDark.value ? 'dark' : 'light') } catch (e) { /* ignore */ }
}

const chartFont = 'Poppins, system-ui, -apple-system, Segoe UI, Roboto, sans-serif'

// Visual-only ECharts theme. Series/data/logic are untouched; any explicit
// colors set inside each chart option still take precedence over this.
function buildChartTheme(dark) {
  const axisLabel = dark ? '#94a3b8' : '#475569'
  const axisLine  = dark ? 'rgba(148,163,184,0.30)' : 'rgba(15,23,42,0.18)'
  const splitLine = dark ? 'rgba(148,163,184,0.10)' : 'rgba(15,23,42,0.07)'
  const axis = {
    axisLine: { lineStyle: { color: axisLine } },
    axisTick: { lineStyle: { color: axisLine } },
    axisLabel: { color: axisLabel },
    splitLine: { lineStyle: { color: splitLine } },
  }
  return {
    color: PALETTE,
    backgroundColor: 'transparent',
    textStyle: { color: dark ? '#cbd5e1' : '#334155', fontFamily: chartFont },
    title: { textStyle: { color: dark ? '#e2e8f0' : '#0f172a' } },
    categoryAxis: axis,
    valueAxis: axis,
    legend: { textStyle: { color: dark ? '#cbd5e1' : '#334155' } },
    tooltip: {
      backgroundColor: dark ? 'rgba(15,23,42,0.96)' : 'rgba(255,255,255,0.98)',
      borderColor: dark ? 'rgba(148,163,184,0.25)' : 'rgba(15,23,42,0.12)',
      borderWidth: 1,
      textStyle: { color: dark ? '#e2e8f0' : '#0f172a' },
      extraCssText: dark
        ? 'box-shadow:0 10px 30px rgba(0,0,0,0.5);border-radius:12px;'
        : 'box-shadow:0 10px 30px rgba(15,23,42,0.14);border-radius:12px;',
    },
  }
}
provide(THEME_KEY, computed(() => buildChartTheme(isDark.value)))

/* ───────────────────────── Live clock (Monterrey) ───────────────────────── */
const clock = reactive({ time: '--:--:--', date: '' })
let clockTimer = null
function tickClock() {
  const now = new Date()
  clock.time = now.toLocaleTimeString('es-MX', {
    timeZone: 'America/Monterrey', hour: '2-digit', minute: '2-digit', second: '2-digit',
  })
  clock.date = now.toLocaleDateString('es-MX', {
    timeZone: 'America/Monterrey', weekday: 'long', day: '2-digit', month: 'short',
  })
}
onMounted(() => { tickClock(); clockTimer = setInterval(tickClock, 1000) })
onUnmounted(() => { if (clockTimer) clearInterval(clockTimer) })

/* ─────────────── Derived KPIs for hero strips (no new fetches) ─────────────── */
const opsTotalOrders  = computed(() => (ops.ordersPerClient || []).reduce((s, r) => s + Number(r.orders || 0), 0))
const maintTotalMoney = computed(() => (maint.perUnitMoney || []).reduce((s, r) => s + Number(r.amount || 0), 0))
const maintTotalKm    = computed(() => (maint.perUnitKm || []).reduce((s, r) => s + Number(r.km || 0), 0))
const rrhhTotalToday  = computed(() => (rrhh.perClerk || []).reduce((s, r) => s + Number(r.count || 0), 0))
const rrhhMonthTotal  = computed(() => (rrhhMonthlySeries.value || []).reduce((s, r) => s + Number(r.total || 0), 0))

const pendingBillingByClient = ref([])

async function fetchPendingBillingByClient() {
  const base = apiBase()
  const r = await axios.get(`${base}/dashboard/pending-billing-subtotal-by-client`, {
    params: { limit: 10 }
  })
  pendingBillingByClient.value = r.data.results || []
}

async function fetchOperations(){
  const base = apiBase()
  const [c1, c2, c3, c4, c5] = await Promise.all([
    axios.get(`${base}/dashboard/orders-per-client`, { params: { date: opsDate.value, limit: 1000 } }),
    axios.get(`${base}/dashboard/active-units`),
    axios.get(`${base}/dashboard/type-frequency`, { params: { date: opsDate.value } }),
    axios.get(`${base}/dashboard/orders-per-sucursal-count`, { params: { date: opsDate.value } }),     // NEW
    axios.get(`${base}/dashboard/subtotal-per-sucursal-sum`, { params: { date: opsDate.value } }),     // NEW
  ])
  ops.ordersPerClient   = c1.data.results || []
  ops.activeUnits       = c2.data.results || []
  ops.typeFrequency     = c3.data.results || []
  ops.sucursalCount     = c4.data.results || []   // NEW
  ops.sucursalSubtotal  = c5.data.results || []   // NEW
}

async function fetchAccounting(){
  const base = apiBase()
  const [c1, c2, c3, c4, c5] = await Promise.all([
    axios.get(`${base}/dashboard/invoices-today`, { params: { date: accDate.value } }),
    axios.get(`${base}/dashboard/payments-today`, { params: { date: accDate.value, transaction_type: txType.value } }),
    axios.get(`${base}/dashboard/uninvoiced-orders-count`),
    axios.get(`${base}/dashboard/balance-per-client`),           // NEW (fetch all, we’ll Top-N in FE)
    axios.get(`${base}/dashboard/total-credit-balance`)          // NEW
  ])
  acc.invoices = c1.data
  acc.payments = c2.data
  acc.uninvoiced = c3.data.count || 0
  acc.balPerClient = c4.data.results || []
  acc.totalCredit  = (c5.data && c5.data.total_credit) || 0
}

async function fetchRRHH() {
  const base = apiBase()
  const r = await axios.get(`${base}/dashboard/ot-per-clerk`, { params: { date: rrhhDate.value } })
  rrhh.perClerk = r.data?.results || []
}

let rrhhMonthlyFirstLoad = true

async function fetchRRHHMonthly() {
  const base = apiBase()

  const [yearStr, monthStr] = rrhhMonthYear.value.split("-")
  const year = Number(yearStr)
  const month = Number(monthStr)

  const r = await axios.get(`${base}/dashboard/rrhh-monthly-clerk-series`, {
    params: { year, month },
  })

  rrhhMonthlyDays.value   = r.data?.days || []
  rrhhMonthlySeries.value = r.data?.series || []

  // keep existing selection where possible
  const validIds = new Set((rrhhMonthlySeries.value || []).map(s => s.clerk_id))
  rrhhSelectedClerks.value = (rrhhSelectedClerks.value || []).filter(id => validIds.has(id))

  // first load → select ALL by default
  if (rrhhMonthlyFirstLoad && rrhhMonthlySeries.value.length) {
    rrhhSelectedClerks.value = rrhhMonthlySeries.value.map(s => s.clerk_id)
  }
  rrhhMonthlyFirstLoad = false
}

async function fetchEstadisticoClientes() {
  const base = apiBase()
  const month = estadisticoMonth.value
  const year = Number(String(month || '').slice(0, 4))
  const loadYear = Number.isFinite(year) && year !== estadisticoYearly.loadedYear

  const requests = [
    axios.get(`${base}/dashboard/estadistico-clientes-monthly`, {
      params: { month },
    }),
  ]
  if (loadYear) {
    requests.push(axios.get(`${base}/dashboard/estadistico-clientes-yearly`, {
      params: { year },
    }))
  }

  const [monthly, yearly] = await Promise.all(requests)
  estadistico.days = monthly.data?.days || []
  estadistico.countRows = monthly.data?.counts?.rows || []
  estadistico.countTotalDaily = monthly.data?.counts?.total_daily || []
  estadistico.countGrandTotal = Number(monthly.data?.counts?.grand_total || 0)
  estadistico.subtotalRows = monthly.data?.subtotals?.rows || []
  estadistico.subtotalTotalDaily = monthly.data?.subtotals?.total_daily || []
  estadistico.subtotalGrandTotal = Number(monthly.data?.subtotals?.grand_total || 0)

  if (yearly) {
    estadisticoYearly.countRows = yearly.data?.counts?.rows || []
    estadisticoYearly.countTotalMonthly = yearly.data?.counts?.total_monthly || []
    estadisticoYearly.countGrandTotal = Number(yearly.data?.counts?.grand_total || 0)
    estadisticoYearly.subtotalRows = yearly.data?.subtotals?.rows || []
    estadisticoYearly.subtotalTotalMonthly = yearly.data?.subtotals?.total_monthly || []
    estadisticoYearly.subtotalGrandTotal = Number(yearly.data?.subtotals?.grand_total || 0)
    estadisticoYearly.loadedYear = year
  }
}


async function fetchOpsMonthly() {
  const base = apiBase()
  const [c1, c2, c3] = await Promise.all([
    axios.get(`${base}/dashboard/ot-daily-count`, { params: { month: opsMonth.value } }),
    axios.get(`${base}/dashboard/subtotal-daily-sum`, { params: { month: opsMonth.value } }),
    axios.get(`${base}/dashboard/insurer-services-daily`, { params: { month: opsMonth.value } })
  ])
  ops.dailyCount = c1.data.results || []
  ops.dailySubtotal = c2.data.results || []
  ops.insurerDaily = c3.data.results || []
  ops.insurerTotals = c3.data.totals || {}
}

async function fetchOperationsMonthly() {
  const base = apiBase()
  const r = await axios.get(`${base}/dashboard/ops-monthly-series`, {
    params: { year: opsYear.value }
  })
  ops.monthlyCount = r.data?.count_per_month || []
  ops.monthlySubtotal = r.data?.subtotal_per_month || []
}

const maintDate = ref(opsDate.value)

const maint = reactive({
  perUnitCount: [],   // {unit_short_id, count}
  perUnitMoney: [],   // {unit_short_id, amount}
  perUnitKm: [],      // {unit_short_id, km}
  byPrefix: []        // {prefix, count}
})

async function fetchMaintenance() {
  const base = apiBase()
  const [a, b, c, d] = await Promise.all([
    axios.get(`${base}/dashboard/maint-assignations-per-unit`, { params: { date: maintDate.value } }),
    axios.get(`${base}/dashboard/maint-money-per-unit`,        { params: { date: maintDate.value } }),
    axios.get(`${base}/dashboard/maint-km-per-unit`,           { params: { date: maintDate.value } }),
    axios.get(`${base}/dashboard/maint-ot-by-prefix`,          { params: { date: maintDate.value } })
  ])
  maint.perUnitCount = a.data?.results || []
  maint.perUnitMoney = b.data?.results || []
  maint.perUnitKm    = c.data?.results || []
  maint.byPrefix     = d.data?.results || []
}

/* ── Unidades: per-unit totals laid out in category columns ────────────────── */
const maintSections = [
  { key: 'graficas', label: 'Gráficas' },
  { key: 'rendimiento', label: 'Rendimiento por unidad' },
]
const maintSection = ref('graficas')

const unitStatsStart = ref(todayISO.slice(0, 8) + '01')
const unitStatsEnd = ref(todayISO)
const unitStatsSort = ref('services')
const unitStatsOnlyActive = ref(false)
const unitStatsOnlyIdle = ref(false)
const unitStatsLoading = ref(false)
const unitStats = ref([])   // {id, unit_short_id, unit_category, services, money, km, last_service_at}

// Category buckets, mirroring the unit_category values used by the units panel
const UNIT_CATEGORY_COLUMNS = [
  { key: 'ab', title: 'Tipo A/B', categories: ['A', 'B'] },
  { key: 'cd', title: 'Tipo C/D', categories: ['C', 'D'] },
  { key: 'montacargas', title: 'Montacargas', categories: ['MONTACARGAS'] },
  { key: 'otro', title: 'Otro', categories: null },   // catch-all
]
const unitStatsCategory = ref('ab')

// The two activity toggles are opposites, so only one can be on at a time
watch(unitStatsOnlyActive, on => { if (on) unitStatsOnlyIdle.value = false })
watch(unitStatsOnlyIdle, on => { if (on) unitStatsOnlyActive.value = false })

// A unit idle for this long gets the same red treatment as the units panel
const UNIT_STALE_HOURS = 24
const nowMs = ref(Date.now())

function hoursSinceNow(iso) {
  if (!iso) return null
  const t = new Date(iso).getTime()
  if (Number.isNaN(t)) return null
  return (nowMs.value - t) / 3600000
}

function isUnitStale(unit) {
  const h = hoursSinceNow(unit.last_service_at)
  return h !== null && h >= UNIT_STALE_HOURS
}

// Idle = nothing in the selected range, or flagged red for being stale
function isUnitIdle(unit) {
  return !Number(unit.services || 0) || isUnitStale(unit)
}

function elapsedLabel(iso) {
  const h = hoursSinceNow(iso)
  if (h === null) return ''
  if (h < 1) return `hace ${Math.max(1, Math.round(h * 60))} min`
  if (h < 48) return `hace ${Math.round(h)} h`
  const days = Math.floor(h / 24)
  const rest = Math.round(h % 24)
  return rest ? `hace ${days} d ${rest} h` : `hace ${days} d`
}

function fmtDateTime(iso) {
  if (!iso) return '—'
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return '—'
  return d.toLocaleString('es-MX', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })
}

async function fetchUnitStats() {
  unitStatsLoading.value = true
  try {
    const r = await axios.get(`${apiBase()}/dashboard/maint-unit-stats-by-category`, {
      params: { start_date: unitStatsStart.value, end_date: unitStatsEnd.value }
    })
    unitStats.value = r.data?.results || []
  } finally {
    unitStatsLoading.value = false
  }
}

let unitStatsClock = null
onMounted(() => { unitStatsClock = setInterval(() => { nowMs.value = Date.now() }, 30000) })
onUnmounted(() => { if (unitStatsClock) clearInterval(unitStatsClock) })

const unitStatsTotals = computed(() => {
  const rows = unitStats.value || []
  return {
    units: rows.filter(u => Number(u.services || 0) > 0).length,
    services: rows.reduce((s, u) => s + Number(u.services || 0), 0),
    money: rows.reduce((s, u) => s + Number(u.money || 0), 0),
    km: rows.reduce((s, u) => s + Number(u.km || 0), 0),
  }
})

function sortUnitStats(list) {
  const byUnit = (a, b) => String(a.unit_short_id).localeCompare(String(b.unit_short_id), undefined, { numeric: true })
  if (unitStatsSort.value === 'unit') return [...list].sort(byUnit)
  const key = unitStatsSort.value
  return [...list].sort((a, b) => (Number(b[key] || 0) - Number(a[key] || 0)) || byUnit(a, b))
}

function unitCategoryKey(unit) {
  const cat = (unit.unit_category || '').toUpperCase()
  const col = UNIT_CATEGORY_COLUMNS.find(c => c.categories && c.categories.includes(cat))
  return col ? col.key : 'otro'
}

// Rows surviving the activity toggles, bucketed by category
const unitStatsBuckets = computed(() => {
  const buckets = {}
  for (const col of UNIT_CATEGORY_COLUMNS) buckets[col.key] = []
  for (const u of unitStats.value || []) {
    if (unitStatsOnlyActive.value && !Number(u.services || 0)) continue
    if (unitStatsOnlyIdle.value && !isUnitIdle(u)) continue
    buckets[unitCategoryKey(u)].push(u)
  }
  return buckets
})

const unitStatsCounts = computed(() => {
  const counts = {}
  for (const col of UNIT_CATEGORY_COLUMNS) counts[col.key] = unitStatsBuckets.value[col.key].length
  return counts
})

const unitStatsVisible = computed(() =>
  sortUnitStats(unitStatsBuckets.value[unitStatsCategory.value] || [])
)

const creditMonth = ref(rrhhMonthYear /* or reuse local year/month from before */)

const accCreditSeries = ref([])

async function fetchCreditTimeseries() {
  const base = apiBase()
  const r = await axios.get(`${base}/dashboard/credit-timeseries`, {
    params: { month: creditMonth.value } // "YYYY-MM"
  })
  accCreditSeries.value = r.data.points || []
}

const monthLabels = ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic']

const opsMonthlyCountOption = computed(() => {
  const arr = ops.monthlyCount || []
  const data = new Array(12).fill(0)
  for (const row of arr) {
    const idx = (row.month || 0) - 1
    if (idx >= 0 && idx < 12) data[idx] = Number(row.count || 0)
  }

  return {
    tooltip: { trigger: 'axis' },
    grid: { left: 8, right: 52, top: 42, bottom: 24, containLabel: true },
    xAxis: { type: 'category', boundaryGap: false, data: monthLabels, axisTick: { show: false } },
    yAxis: { type: 'value', splitNumber: 4 },
    series: [{
      type: 'line',
      data,
      ...lineLook('#ef4444'),
      ...peakLastDecor(fmtInt),
    }]
  }
})

const uninvoicedMonth = ref(todayISO.slice(0, 7))  // "YYYY-MM"
const accUninvoicedSubtotalSeries = ref([])

async function fetchUninvoicedSubtotalDaily() {
  const base = apiBase()
  const r = await axios.get(`${base}/dashboard/uninvoiced-subtotal-daily`, {
    params: { month: uninvoicedMonth.value }
  })
  accUninvoicedSubtotalSeries.value = r.data.points || []
}

const accUninvoicedSubtotalDailyOption = computed(() => {
  const pts = accUninvoicedSubtotalSeries.value || []
  return {
    tooltip: {
      trigger: 'axis',
      formatter: (params) => {
        const p = params[0]
        const num = Number(p.value ?? 0)
        const val = num.toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })
        return `${p.axisValue}<br/>Subtotal sin factura: <b>${val}</b>`
      }
    },
    grid: { left: 8, right: 8, top: 24, bottom: 24, containLabel: true },
    xAxis: { type: 'category', boundaryGap: false, data: pts.map(p => p.date), axisTick: { show: false } },
    yAxis: {
      type: 'value',
      splitNumber: 4,
      axisLabel: {
        formatter: (v) => (Number(v) || 0).toLocaleString('es-MX', {
          style: 'currency', currency: 'MXN', maximumFractionDigits: 0
        })
      }
    },
    series: [{
      type: 'line',
      data: pts.map(p => p.subtotal),
      ...lineLook('#f59e0b'),
      ...avgLineDecor(fmtMoney0),
    }]
  }
})

const opsMonthlySubtotalOption = computed(() => {
  const arr = ops.monthlySubtotal || []
  const data = new Array(12).fill(0)
  for (const row of arr) {
    const idx = (row.month || 0) - 1
    if (idx >= 0 && idx < 12) data[idx] = Number(row.subtotal || 0)
  }

  return {
    tooltip: {
      trigger: 'axis',
      formatter: (params) => {
        const p = params[0]
        const val = (Number(p.value) || 0).toLocaleString('es-MX', {
          style: 'currency',
          currency: 'MXN'
        })
        return `${p.axisValue}<br/>Subtotal: <b>${val}</b>`
      }
    },
    grid: { left: 8, right: 64, top: 42, bottom: 24, containLabel: true },
    xAxis: { type: 'category', boundaryGap: false, data: monthLabels, axisTick: { show: false } },
    yAxis: {
      type: 'value',
      splitNumber: 4,
      axisLabel: {
        formatter: (v) => (Number(v) || 0).toLocaleString('es-MX', {
          style: 'currency',
          currency: 'MXN',
          maximumFractionDigits: 0
        })
      }
    },
    series: [{
      type: 'line',
      data,
      ...lineLook('#ef4444'),
      ...peakLastDecor(fmtMoney0),
    }]
  }
})

const typeFreqOption = computed(()=>({
  tooltip: { trigger:'axis', axisPointer: { type: 'shadow' } },
  grid: { left: 6, right: 6, top: 20, bottom: 40, containLabel: true },
  xAxis: { type:'category', data: ops.typeFrequency.map(d => d.type_name || '—'), axisTick: { show: false } },
  yAxis: { type:'value', splitNumber: 4 },
  series: [{
    type:'bar',
    barMaxWidth: 34,
    itemStyle: { color: barGradient('#0ea5e9'), borderRadius: BAR_RADIUS },
    data: ops.typeFrequency.map(d => Number(d.count||0)),
  }]
}))

const AXA_COLORS = { accepted: '#22c55e', timedOut: '#f59e0b', errored: '#ef4444' }

const insurerDailyOption = computed(() => {
  const rows = ops.insurerDaily || []
  return {
    tooltip: {
      trigger: 'axis',
      axisPointer: { type: 'shadow' },
      formatter: (params) => {
        const idx = params[0]?.dataIndex ?? 0
        const r = rows[idx] || {}
        const lines = params.map(p => `${p.marker} ${p.seriesName}: <b>${p.value}</b>`)
        lines.push(`Total recibidos: <b>${r.total || 0}</b>`)
        if (r.rejected) lines.push(`Rechazados: <b>${r.rejected}</b>`)
        if (r.error_events) lines.push(`Errores de API registrados: <b>${r.error_events}</b>`)
        return `${r.date || ''}<br/>${lines.join('<br/>')}`
      }
    },
    legend: { data: ['Aceptados', 'Timeouts', 'Con error'], top: 0 },
    grid: { left: 6, right: 6, top: 32, bottom: 24, containLabel: true },
    xAxis: { type: 'category', data: rows.map(r => (r.date || '').slice(8)), axisTick: { show: false } },
    yAxis: { type: 'value', splitNumber: 4, minInterval: 1 },
    series: [
      { name: 'Aceptados', type: 'bar', stack: 'axa', barMaxWidth: 22, itemStyle: { color: AXA_COLORS.accepted }, data: rows.map(r => Number(r.accepted || 0)) },
      { name: 'Timeouts',  type: 'bar', stack: 'axa', barMaxWidth: 22, itemStyle: { color: AXA_COLORS.timedOut }, data: rows.map(r => Number(r.timed_out || 0)) },
      { name: 'Con error', type: 'bar', stack: 'axa', barMaxWidth: 22, itemStyle: { color: AXA_COLORS.errored }, data: rows.map(r => Number(r.errored || 0)) },
    ]
  }
})

const wsOps = useDashboardWS('operations')
const wsAcc = useDashboardWS('accounting')

let to1=null, to2=null
const refetchOps = ()=>{ clearTimeout(to1); to1 = setTimeout(fetchOperations, 400) }
const refetchAcc = ()=>{ clearTimeout(to2); to2 = setTimeout(fetchAccounting, 400) }

wsOps.onMessage(m => { if(['active_units_changed','orders_or_types_changed', 'orders_sucursal_changed'].includes(m.topic)) refetchOps() })
wsAcc.onMessage(m => { if(m.topic==='accounting_changed') refetchAcc() })

const wsClassOps = computed(()=> ({ 'pill-open': wsOps.status==='open', 'pill-retry': wsOps.status==='retry' }))
const wsClassAcc = computed(()=> ({ 'pill-open': wsAcc.status==='open', 'pill-retry': wsAcc.status==='retry' }))

const ordersPerClientPieOption = computed(() => {
  const { top, others } = opsTopClients.value
  const data = top.map(r => ({
    name: r.client_name_ph || '—',
    value: Number(r.orders || 0),
    itemStyle: { color: colorFor(r.client_name_ph || '—') }
  }))
  if (others > 0) {
    data.push({ name: 'Otros', value: others, itemStyle: { color: '#9AA1AC' } })
  }
  return {
    tooltip: { trigger: 'item', formatter: '{b}: {c} ({d}%)' },
    legend: { show: false },
    series: [{
      type: 'pie',
      radius: ['52%', '78%'],
      center: ['50%', '50%'],
      avoidLabelOverlap: true,
      padAngle: 2,
      label: { show: false },
      labelLine: { show: false },
      itemStyle: {
        borderColor: isDark.value ? '#0f1626' : '#ffffff',
        borderWidth: 2,
        borderRadius: 6,
      },
      emphasis: { scaleSize: 6, itemStyle: { shadowBlur: 16, shadowColor: 'rgba(2,6,23,0.35)' } },
      data
    }]
  }
})

const ordersPerClientLegend = computed(() => {
  const { top, others } = opsTopClients.value
  const totalTop = top.reduce((s, r) => s + Number(r.orders || 0), 0)
  const total = totalTop + (others || 0) || 1

  const list = top.map(r => {
    const name = r.client_name_ph || '—'
    const value = Number(r.orders || 0)
    const pct = Math.round((100 * value) / total)
    return { name, value, pct, color: colorFor(name) }
  })

  if (others > 0) {
    const pct = Math.round((100 * others) / total)
    list.push({ name: 'Otros', value: others, pct, color: '#9AA1AC' })
  }
  return list
})

const sucursalCountPieOption = computed(() => {
  const rows = ops.sucursalCount || []
  const data = rows.map(r => ({
    name: r.sucursal || 'Sin sucursal',
    value: Number(r.count || 0),
    itemStyle: { color: colorFor(r.sucursal || 'Sin sucursal') }
  }))
  return {
    tooltip: { trigger: 'item', formatter: '{b}: {c} ({d}%)' },
    legend: { show: false },
    series: [{
      type: 'pie',
      radius: ['52%','78%'],
      center: ['50%', '50%'],
      avoidLabelOverlap: true,
      padAngle: 2,
      label: { show: false },
      labelLine: { show: false },
      itemStyle: {
        borderColor: isDark.value ? '#0f1626' : '#ffffff',
        borderWidth: 2,
        borderRadius: 6,
      },
      emphasis: { scaleSize: 6, itemStyle: { shadowBlur: 16, shadowColor: 'rgba(2,6,23,0.35)' } },
      data
    }]
  }
})

const sucursalCountLegend = computed(() => {
  const rows = ops.sucursalCount || []
  const total = rows.reduce((s,r)=>s+Number(r.count||0), 0) || 1
  return rows.map(r => {
    const name = r.sucursal || 'Sin sucursal'
    const value = Number(r.count||0)
    const pct = Math.round((100*value)/total)
    return { name, value, pct, color: colorFor(name) }
  })
})

const sucursalLegend = computed(() =>
  (ops.sucursalSubtotal || []).map(r => ({ name: r.sucursal || 'Sin sucursal', color: colorFor(r.sucursal || 'Sin sucursal') }))
)

const otDailyCountOption = computed(() => {
  const dates = ops.dailyCount.map(x => x.date)
  const values = ops.dailyCount.map(x => Number(x.count || 0))
  return {
    tooltip: { trigger: 'axis' },
    grid: { left: 8, right: 8, top: 18, bottom: 28, containLabel: true },
    xAxis: { type: 'category', boundaryGap: false, data: dates, axisTick: { show: false } },
    yAxis: { type: 'value', splitNumber: 4 },
    series: [{ type: 'line', data: values, ...lineLook(LINE_ACCENT), ...avgLineDecor(fmtInt) }]
  }
})

const subtotalDailySumOption = computed(() => {
  const dates = ops.dailySubtotal.map(x => x.date)
  const values = ops.dailySubtotal.map(x => Number(x.amount || 0))
  return {
    tooltip: {
      trigger: 'axis',
      valueFormatter: v => (Number(v)||0).toLocaleString('es-MX', { style:'currency', currency:'MXN' })
    },
    grid: { left: 8, right: 8, top: 18, bottom: 28, containLabel: true },
    xAxis: { type: 'category', boundaryGap: false, data: dates, axisTick: { show: false } },
    yAxis: {
      type: 'value',
      splitNumber: 4,
      axisLabel: { formatter: v => (Number(v)||0).toLocaleString('es-MX', { style:'currency', currency:'MXN', maximumFractionDigits: 0 }) }
    },
    series: [{ type: 'line', data: values, ...lineLook('#22c55e'), ...avgLineDecor(fmtMoney0) }]
  }
})

const TOP_N = 5

const opsTopClients = computed(() => {
  const rows = (ops.ordersPerClient || []).slice().sort((a, b) => Number(b.orders||0) - Number(a.orders||0))
  const top = rows.slice(0, TOP_N)
  const rest = rows.slice(TOP_N)
  const others = rest.reduce((s, r) => s + Number(r.orders || 0), 0)
  return { top, others } // template auto-unwraps
})

const sucursalSubtotalBarOption = computed(() => {
  const labels = (ops.sucursalSubtotal || []).map(r => r.sucursal || 'Sin sucursal')
  const values = (ops.sucursalSubtotal || []).map(r => Number(r.amount || 0))

  return {
    tooltip: {
      trigger: 'axis',
      axisPointer: { type: 'shadow' },
      formatter: (params) => {
        const p = params[0]
        const name = labels[p.dataIndex]
        const val  = (Number(p.value)||0).toLocaleString('es-MX', { style:'currency', currency:'MXN' })
        return `${name}<br/>Subtotal: <b>${val}</b>`
      }
    },
    grid: { left: 8, right: 8, top: 24, bottom: 24, containLabel: true },
    xAxis: {
      type: 'category',
      data: labels,
      axisLabel: { show: false }   // hide crowded labels; legend shows mapping
    },
    yAxis: {
      type: 'value',
      axisLabel: { formatter: v => (Number(v)||0).toLocaleString('es-MX', { style:'currency', currency:'MXN', maximumFractionDigits: 0 }) }
    },
    series: [{
      type: 'bar',
      barMaxWidth: 40,
      data: values.map((v, i) => ({ value: v, itemStyle: { color: barGradient(colorFor(labels[i])), borderRadius: BAR_RADIUS } }))
    }]
  }
})

const BAL_TOP_N = 8  // adjust as you like

const accBalTop = computed(() => {
  const rows = (acc.balPerClient || []).slice().sort((a,b)=>Number(b.amount||0)-Number(a.amount||0))
  const top = rows.slice(0, BAL_TOP_N)
  const others = rows.slice(BAL_TOP_N).reduce((s,r)=>s+Number(r.amount||0), 0)
  return { top, others }
})

const balPerClientBarOption = computed(() => {
  const { top, others } = accBalTop.value
  const labels = top.map(r => r.client_name || '—')
  const values = top.map(r => Number(r.amount || 0))

  if (others > 0) {
    labels.push('Otros')
    values.push(others)
  }

  return {
    tooltip: {
      trigger: 'axis',
      axisPointer: { type: 'shadow' },
      formatter: (params) => {
        const i = params[0]
        const val = (Number(i.value)||0).toLocaleString('es-MX', { style:'currency', currency:'MXN' })
        return `${i.axisValue}<br/>Balance: <b>${val}</b>`
      }
    },
    grid: { left: 8, right: 8, top: 24, bottom: 24, containLabel: true },
    xAxis: { type: 'category', data: labels, axisLabel: { show: false } }, // custom legend below
    yAxis: {
      type: 'value',
      axisLabel: { formatter: v => (Number(v)||0).toLocaleString('es-MX', { style:'currency', currency:'MXN', maximumFractionDigits: 0 }) }
    },
    series: [{
      type: 'bar',
      barMaxWidth: 40,
      data: values.map((v, i) => ({
        value: v,
        itemStyle: {
          color: barGradient(labels[i] === 'Otros' ? '#9AA1AC' : colorFor(labels[i])),
          borderRadius: BAR_RADIUS
        }
      }))
    }]
  }
})

const balPerClientLegend = computed(() => {
  const { top, others } = accBalTop.value
  const totalTop = top.reduce((s, r) => s + Number(r.amount || 0), 0)
  const total = totalTop + (others || 0) || 1
  const list = top.map(r => {
    const name = r.client_name || '—'
    const value = Number(r.amount || 0)
    const pct = Math.round((100 * value) / total)
    return { name, value, pct, color: colorFor(name) }
  })
  if (others > 0) {
    const pct = Math.round((100 * others) / total)
    list.push({ name: 'Otros', value: others, pct, color: '#9AA1AC' })
  }
  return list
})

const rrhhPerClerkOption = computed(() => {
  const rows = rrhh.perClerk || []
  const labels = rows.map(r => r.clerk_name || '—')
  const values = rows.map(r => Number(r.count || 0))

  if (!rows.length) {
    return { xAxis: { type: 'category', data: [] }, yAxis: { type:'value' }, series: [{ type:'bar', data: [] }] }
  }

  // find best/worst
  const maxVal = Math.max(...values)
  const minVal = Math.min(...values)

  return {
    tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
    grid: { left: 8, right: 8, top: 30, bottom: 24, containLabel: true },
    xAxis: { type: 'category', data: labels, axisLabel: { show: false }, axisTick: { show: false } }, // we’ll show mapping in a legend-like list
    yAxis: { type: 'value', splitNumber: 4 },
    series: [{
      type: 'bar',
      barMaxWidth: 40,
      label: { show: true, position: 'top', color: 'inherit', fontWeight: 700, fontSize: 11 },
      emphasis: { focus: 'series' },
      data: values.map((v) => {
        const c = v === maxVal ? '#22c55e' :           // best (green)
                  v === minVal ? '#ef4444' : '#3b82f6' // worst (red) else blue
        return { value: v, itemStyle: { color: barGradient(c), borderRadius: [8, 8, 2, 2] } }
      })
    }]
  }
})

const bestWorstIds = computed(() => {
  const rows = rrhh.perClerk || []
  if (!rows.length) return { best: null, worst: null }
  // if ties exist, first occurrence gets the class
  const counts = rows.map(r => Number(r.count||0))
  const maxVal = Math.max(...counts)
  const minVal = Math.min(...counts)
  const bestIdx = counts.indexOf(maxVal)
  const worstIdx = counts.indexOf(minVal)
  return {
    best: rows[bestIdx]?.clerk_id ?? null,
    worst: rows[worstIdx]?.clerk_id ?? null
  }
})

const invSummarySplit = computed(() => {
  const s = acc.invoices?.summary || {}
  let credit = s.total_amount_credit
  let contado = s.total_amount_contado

  if (credit == null || contado == null) {
    // derive if backend not yet updated
    let c = 0, k = 0
    for (const r of (acc.invoices?.results || [])) {
      const amt = Number(r.amount || 0)
      if ((r.invoice_type || '').toLowerCase() === 'credito') c += amt
      else if ((r.invoice_type || '').toLowerCase() === 'contado') k += amt
    }
    credit = credit ?? c
    contado = contado ?? k
  }

  return {
    count: s.count ?? (acc.invoices?.results?.length || 0),
    total_balance: s.total_balance ?? 0,
    total_amount_credit: credit || 0,
    total_amount_contado: contado || 0,
  }
})


const countPerUnitOption = computed(() => {
  const labels = maint.perUnitCount.map(x => x.unit_short_id)
  const data   = maint.perUnitCount.map(x => Number(x.count||0))
  return {
    tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
    grid: { left: 8, right: 8, top: 24, bottom: 24, containLabel: true },
    xAxis: { type:'category', data: labels, axisLabel: { show: false } },
    yAxis: { type:'value' },
    series: [{ type:'bar', barMaxWidth: 38,
      data: data.map((v,i)=>({ value:v, itemStyle:{ color: barGradient(colorFor(labels[i])), borderRadius: BAR_RADIUS }}))
    }]
  }
})

const moneyPerUnitOption = computed(() => {
  const labels = maint.perUnitMoney.map(x => x.unit_short_id)
  const data   = maint.perUnitMoney.map(x => Number(x.amount||0))
  return {
    tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' },
      formatter: p => {
        const i = p[0]; const val = (Number(i.value)||0).toLocaleString('es-MX',{style:'currency',currency:'MXN'})
        return `${i.axisValue}<br/>Monto: <b>${val}</b>`
      }
    },
    grid: { left: 8, right: 8, top: 24, bottom: 24, containLabel: true },
    xAxis: { type:'category', data: labels, axisLabel: { show: false } },
    yAxis: { type:'value',
      axisLabel: { formatter: v => (Number(v)||0).toLocaleString('es-MX',{style:'currency',currency:'MXN',maximumFractionDigits:0}) }
    },
    series: [{ type:'bar', barMaxWidth: 38,
      data: data.map((v,i)=>({ value:v, itemStyle:{ color: barGradient(colorFor(labels[i])), borderRadius: BAR_RADIUS }}))
    }]
  }
})

const kmPerUnitOption = computed(() => {
  const labels = maint.perUnitKm.map(x => x.unit_short_id)
  const data   = maint.perUnitKm.map(x => Number(x.km||0))
  return {
    tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
    grid: { left: 8, right: 8, top: 24, bottom: 24, containLabel: true },
    xAxis: { type:'category', data: labels, axisLabel: { show: false } },
    yAxis: { type:'value' },
    series: [{ type:'bar', barMaxWidth: 38,
      data: data.map((v,i)=>({ value:v, itemStyle:{ color: barGradient(colorFor(labels[i])), borderRadius: BAR_RADIUS }}))
    }]
  }
})

const otByPrefixOption = computed(() => {
  const labels = maint.byPrefix.map(x => x.prefix)
  const data   = maint.byPrefix.map(x => Number(x.count||0))
  return {
    tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
    grid: { left: 8, right: 8, top: 24, bottom: 24, containLabel: true },
    xAxis: { type:'category', data: labels },
    yAxis: { type:'value' },
    series: [{ type:'bar', barMaxWidth: 38,
      data: data.map((v,i)=>({ value:v, itemStyle:{ color: barGradient(colorFor(labels[i])), borderRadius: BAR_RADIUS }}))
    }]
  }
})


const rrhhMonthlyChartOption = computed(() => {
  const days = rrhhMonthlyDays.value || []
  const labels = days.map(d => String(d))

  const allSeries = rrhhMonthlySeries.value || []
  const selectedIds = new Set(rrhhSelectedClerks.value)

  const effectiveSeries = rrhhSelectedClerks.value.length
    ? allSeries.filter(s => selectedIds.has(s.clerk_id))
    : []

  const series = effectiveSeries.map((s) => {
    const c = colorFor(s.clerk_name)
    return {
      name: s.clerk_name,
      type: 'line',
      smooth: 0.4,
      data: s.daily || [],
      symbol: 'circle',
      symbolSize: 6,
      showSymbol: false,
      lineStyle: { width: 2.5, color: c, cap: 'round' },
      itemStyle: { color: c, borderColor: '#fff', borderWidth: 1.5 },
      emphasis: { focus: 'series', scale: 1.3, lineStyle: { width: 3.5 } },
      blur: { lineStyle: { opacity: 0.12 } },
    }
  })

  return {
    tooltip: {
      trigger: 'item',
      formatter: (p) => {
        const day = labels[p.dataIndex] || ''
        return `${p.seriesName}<br/>Día ${day}: <b>${p.data}</b> OT`
      }
    },
    legend: { type: 'scroll', bottom: 0, itemWidth: 14, itemHeight: 8, icon: 'roundRect', itemGap: 14 },
    grid: { left: 10, right: 16, top: 24, bottom: 44, containLabel: true },
    xAxis: { type: 'category', boundaryGap: false, data: labels, axisTick: { show: false } },
    yAxis: { type: 'value', splitNumber: 4 },
    series,
  }
})

const pendingBillingByClientOption = computed(() => {
  const rows = pendingBillingByClient.value || []
  const labels = rows.map(r => r.client_name || '—')
  const values = rows.map(r => Number(r.amount || 0))

  return {
    tooltip: {
      trigger: 'axis',
      axisPointer: { type: 'shadow' },
      formatter: (params) => {
        const p = params[0]
        const val = (Number(p.value) || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })
        return `${p.axisValue}<br/>Subtotal: <b>${val}</b>`
      }
    },
    grid: { left: 8, right: 8, top: 24, bottom: 24, containLabel: true },
    xAxis: { type: 'category', data: labels, axisLabel: { show: false } },
    yAxis: {
      type: 'value',
      axisLabel: {
        formatter: v => (Number(v) || 0).toLocaleString('es-MX', {
          style: 'currency', currency: 'MXN', maximumFractionDigits: 0
        })
      }
    },
    series: [{
      type: 'bar',
      barMaxWidth: 40,
      data: values.map((v, i) => ({
        value: v,
        itemStyle: { color: barGradient(labels[i] === 'Otros' ? '#9AA1AC' : colorFor(labels[i])), borderRadius: BAR_RADIUS }
      }))
    }]
  }
})  


const accCreditTimeseriesOption = computed(() => {
  const pts = accCreditSeries.value || []

  return {
    tooltip: {
      trigger: 'axis',
      formatter: (params) => {
        const p = Array.isArray(params) ? params[0] : params
        const num = Number(p.value ?? 0)   // 👈 use value directly
        const val = num.toLocaleString('es-MX', {
          style: 'currency',
          currency: 'MXN'
        })
        return `${p.axisValue}<br/>Crédito total: <b>${val}</b>`
      }
    },
    grid: { left: 8, right: 8, top: 24, bottom: 24, containLabel: true },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: pts.map(p => p.date),
      axisTick: { show: false },
    },
    yAxis: {
      type: 'value',
      splitNumber: 4,
      axisLabel: {
        formatter: (v) =>
          (Number(v) || 0).toLocaleString('es-MX', {
            style: 'currency',
            currency: 'MXN',
            maximumFractionDigits: 0,
          }),
      },
    },
    series: [
      {
        type: 'line',
        data: pts.map(p => p.credit),
        ...lineLook('#ef4444'),
        ...avgLineDecor(fmtMoney0),
      },
    ],
  }
})


const rrhhMonthlyTotalsSorted = computed(() => {
  return [...(rrhhMonthlySeries.value || [])].sort(
    (a, b) => (b.total || 0) - (a.total || 0)
  )
})

const allClerksSelected = computed(() => {
  const allIds = (rrhhMonthlySeries.value || []).map(s => s.clerk_id)
  return allIds.length > 0 && rrhhSelectedClerks.value.length === allIds.length
})

function toggleClerkRow(id) {
  const current = rrhhSelectedClerks.value || []
  if (current.includes(id)) {
    rrhhSelectedClerks.value = current.filter(x => x !== id)
  } else {
    rrhhSelectedClerks.value = [...current, id]
  }
}

function toggleSelectAllClerks() {
  const allIds = (rrhhMonthlySeries.value || []).map(s => s.clerk_id)

  if (allClerksSelected.value) {
    // all are selected → unselect all
    rrhhSelectedClerks.value = []
  } else {
    // not all selected → select all
    rrhhSelectedClerks.value = allIds
  }
}

function rrhhMatrixCellStyle(value) {
  const n = Number(value || 0)
  const dark = isDark.value
  if (!n) return { background: 'transparent', color: dark ? '#37425a' : '#cbd5e1' }

  // diverging heatmap: red (few) -> amber -> green (many), caps ~8 OT
  const t = Math.min(n / 8, 1)
  const hue = Math.round(t * 120)          // 0 = red, 120 = green
  const fill = (dark ? 0.26 : 0.18) + t * 0.14
  const ring = dark ? 0.45 : 0.30
  return {
    background: `hsla(${hue}, 72%, ${dark ? 46 : 48}%, ${fill.toFixed(3)})`,
    color: dark ? '#f1f5f9' : '#0f172a',
    fontWeight: t > 0.5 ? 800 : 600,
    boxShadow: `inset 0 0 0 1px hsla(${hue}, 72%, 45%, ${ring})`,
  }
}




/* ───────────────────────── Publicidad (Google Ads) ───────────────────────── */
const adsCampaigns = {
  remolque: [
    { name: 'XL General Towing | Search', title: 'XL General Towing | Search' },
  ],
  montacargas: [
    { name: 'XL | Forklift Rental | Search', title: 'XL | Forklift Rental | Search' },
    { name: 'XL | Forklift Transport | Search', title: 'XL | Forklift Transport | Search' },
  ],
}

const ads = reactive({})          // keyed by campaign name -> { loading, data }
const adsInternal = reactive({})  // keyed by section -> { loading, data }
const adsServices = reactive({ loading: true, data: null })  // flat qualifying-services table
const adsNoteBaseUrl = `${(process.env.PUBLIC_BASE_URL || '').replace(/\/+$/, '')}/notes/`

// note-type ids that define each section's internal "Servicios cerrados / Ganancia"
const adsInternalTypes = { remolque: '1,2,4', montacargas: '3' }

const adsInternalMetrics = [
  { key: 'services_closed', label: 'Servicios cerrados', color: '#0ea5e9', axis: 'count', fmt: 'int' },
  { key: 'ganancia',        label: 'Ganancia',           color: '#22c55e', axis: 'money', fmt: 'money' },
]

function isoDaysAgo(n) {
  const d = new Date(local)
  d.setDate(d.getDate() - n)
  return d.toLocaleDateString('en-CA').slice(0, 10)
}

const adsEnd = ref(todayISO)
const adsStart = ref(isoDaysAgo(29))
const adsPreset = ref('30d')

function setAdsPreset(p) {
  adsPreset.value = p
  if (p === '7d') {
    adsStart.value = isoDaysAgo(6); adsEnd.value = todayISO
  } else if (p === '30d') {
    adsStart.value = isoDaysAgo(29); adsEnd.value = todayISO
  } else if (p === 'month') {
    adsStart.value = `${local.getFullYear()}-${String(local.getMonth() + 1).padStart(2, '0')}-01`
    adsEnd.value = todayISO
  }
  refreshAds()
}

function onAdsRangeChange() {
  adsPreset.value = 'custom'
  if (adsStart.value && adsEnd.value && adsStart.value > adsEnd.value) {
    const t = adsStart.value; adsStart.value = adsEnd.value; adsEnd.value = t
  }
  refreshAds()
}

function refreshAds() {
  fetchAds()
  fetchAdsInternal()
  fetchAdsServices()
}

async function fetchAds() {
  const base = apiBase()
  const names = [...adsCampaigns.remolque, ...adsCampaigns.montacargas].map(c => c.name)
  await Promise.all(names.map(async (name) => {
    if (!ads[name]) ads[name] = { loading: true, data: null }
    else ads[name].loading = true
    try {
      const r = await axios.get(`${base}/dashboard/ads-campaign-metrics`, {
        params: { campaign: name, start: adsStart.value, end: adsEnd.value },
      })
      ads[name].data = r.data
    } catch (e) {
      ads[name].data = {
        configured: false,
        error: 'No se pudo conectar con el servidor de anuncios.',
        totals: {}, series: [],
      }
    } finally {
      ads[name].loading = false
    }
  }))
}

async function fetchAdsServices() {
  const base = apiBase()
  adsServices.loading = true
  try {
    const r = await axios.get(`${base}/dashboard/ads-internal-services`, {
      params: { start: adsStart.value, end: adsEnd.value },
    })
    adsServices.data = r.data
  } catch (e) {
    adsServices.data = { error: 'No se pudo cargar la lista de servicios.', results: [], count: 0 }
  } finally {
    adsServices.loading = false
  }
}

async function fetchAdsInternal() {
  const base = apiBase()
  await Promise.all(Object.keys(adsInternalTypes).map(async (section) => {
    if (!adsInternal[section]) adsInternal[section] = { loading: true, data: null }
    else adsInternal[section].loading = true
    try {
      const r = await axios.get(`${base}/dashboard/ads-internal-series`, {
        params: { types: adsInternalTypes[section], start: adsStart.value, end: adsEnd.value },
      })
      adsInternal[section].data = r.data
    } catch (e) {
      adsInternal[section].data = {
        error: 'No se pudo cargar la información del sistema.',
        totals: {}, series: [],
      }
    } finally {
      adsInternal[section].loading = false
    }
  }))
}

onMounted(async () => { await fetchOperations(); await fetchAccounting(); await fetchOpsMonthly(); await fetchRRHH(); await fetchMaintenance(); await fetchUnitStats(); await fetchOperationsMonthly(); await fetchRRHHMonthly(); await fetchCreditTimeseries(); await fetchUninvoicedSubtotalDaily(); await fetchPendingBillingByClient(); await fetchEstadisticoClientes(); refreshAds(); })
</script>

<style scoped>
/* ============================================================
   THEME TOKENS
   ============================================================ */
.dashboard-root {
  --row-h: 32px;
  --head-h: 40px;
  font-family: 'Poppins', system-ui, -apple-system, Segoe UI, Roboto, sans-serif;
  position: relative;
  min-height: 100vh;
  padding: 18px 22px 48px;
  color: var(--text);
  background: var(--bg1);
  transition: background .35s ease, color .35s ease;
  overflow-x: hidden;
}

.theme-dark {
  color-scheme: dark;
  --bg1: #070b16;
  --bg2: #0b1224;
  --text: #e8edf6;
  --text-muted: #9aa7bd;
  --text-dim: #6b7891;
  --surface-solid: #121a2d;
  --border: rgba(148,163,184,.12);
  --border-strong: rgba(148,163,184,.22);
  --accent: #38bdf8;
  --accent-2: #818cf8;
  --accent-grad: linear-gradient(180deg, #38bdf8, #818cf8);
  --accent-grad-h: linear-gradient(90deg, #38bdf8, #818cf8);
  --card-bg: linear-gradient(180deg, rgba(21,29,48,.80), rgba(13,19,34,.80));
  --card-border: rgba(148,163,184,.14);
  --card-border-hover: rgba(56,189,248,.50);
  --card-shadow: 0 10px 30px rgba(2,6,18,.45);
  --card-shadow-hover: 0 18px 44px rgba(2,6,18,.62);
  --card-blur: blur(10px);
  --card-radius: 16px;
  --card-pad: 14px;
  --card-title: #e8edf6;
  --card-topline: linear-gradient(90deg, transparent, rgba(56,189,248,.6), transparent);
  --input-bg: rgba(9,14,28,.7);
  --input-border: rgba(148,163,184,.20);
  --table-head-bg: rgba(11,17,33,.96);
  --head-bg: linear-gradient(180deg, rgba(56,189,248,.14), rgba(56,189,248,.03));
  --row-even: rgba(148,163,184,.05);
  --row-hover: rgba(56,189,248,.10);
  --kpi-bg: rgba(30,41,59,.42);
  --glass: rgba(15,22,40,.66);
}

.theme-light {
  color-scheme: light;
  --bg1: #eaeef6;
  --bg2: #f6f8fc;
  --text: #0f172a;
  --text-muted: #475569;
  --text-dim: #94a3b8;
  --surface-solid: #ffffff;
  --border: rgba(15,23,42,.08);
  --border-strong: rgba(15,23,42,.14);
  --accent: #0284c7;
  --accent-2: #6366f1;
  --accent-grad: linear-gradient(180deg, #0ea5e9, #6366f1);
  --accent-grad-h: linear-gradient(90deg, #0ea5e9, #6366f1);
  --card-bg: rgba(255,255,255,.90);
  --card-border: rgba(15,23,42,.08);
  --card-border-hover: rgba(2,132,199,.40);
  --card-shadow: 0 6px 20px rgba(15,23,42,.07);
  --card-shadow-hover: 0 16px 38px rgba(15,23,42,.14);
  --card-blur: blur(6px);
  --card-radius: 16px;
  --card-pad: 14px;
  --card-title: #0f172a;
  --card-topline: linear-gradient(90deg, transparent, rgba(14,165,233,.5), transparent);
  --input-bg: #ffffff;
  --input-border: #d8dde6;
  --table-head-bg: rgba(255,255,255,.97);
  --head-bg: linear-gradient(180deg, rgba(2,132,199,.10), rgba(2,132,199,.02));
  --row-even: rgba(15,23,42,.03);
  --row-hover: rgba(2,132,199,.07);
  --kpi-bg: #f8fafc;
  --glass: rgba(255,255,255,.72);
}

/* Ambient backdrop */
.ambient {
  position: fixed;
  inset: 0;
  z-index: 0;
  pointer-events: none;
}
.theme-dark .ambient {
  background:
    radial-gradient(900px 520px at 12% -8%, rgba(56,189,248,.16), transparent 60%),
    radial-gradient(820px 520px at 92% 0%, rgba(129,140,248,.16), transparent 60%),
    radial-gradient(700px 600px at 50% 120%, rgba(34,211,238,.08), transparent 60%),
    linear-gradient(180deg, #070b16 0%, #0a1020 100%);
}
.theme-dark .ambient::after {
  content: "";
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(rgba(148,163,184,.05) 1px, transparent 1px),
    linear-gradient(90deg, rgba(148,163,184,.05) 1px, transparent 1px);
  background-size: 42px 42px;
  -webkit-mask-image: radial-gradient(ellipse at 50% 0%, #000 30%, transparent 80%);
  mask-image: radial-gradient(ellipse at 50% 0%, #000 30%, transparent 80%);
}
.theme-light .ambient {
  background:
    radial-gradient(900px 500px at 10% -10%, rgba(14,165,233,.12), transparent 60%),
    radial-gradient(820px 520px at 92% -4%, rgba(99,102,241,.10), transparent 60%),
    linear-gradient(180deg, #eaeef6 0%, #f4f7fc 100%);
}

.dashboard-root > *:not(.ambient) { position: relative; z-index: 1; }

/* ============================================================
   HEADER
   ============================================================ */
.dash-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  padding: 12px 16px;
  border-radius: 18px;
  background: var(--glass);
  border: 1px solid var(--border);
  box-shadow: var(--card-shadow);
  -webkit-backdrop-filter: blur(14px);
  backdrop-filter: blur(14px);
}

.brand { display: flex; align-items: center; gap: 12px; cursor: pointer; }
.logo {
  height: 38px;
  filter: drop-shadow(0 4px 12px rgba(56,189,248,.35));
  transition: transform .2s ease;
}
.brand:hover .logo { transform: scale(1.04) rotate(-2deg); }
.brand-text { display: flex; flex-direction: column; line-height: 1.15; }
.brand-text h1 {
  margin: 0;
  font-size: 19px;
  font-weight: 700;
  letter-spacing: .3px;
  background: var(--accent-grad-h);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}
.brand-sub { font-size: 11px; color: var(--text-muted); letter-spacing: .4px; }

.header-right { display: flex; align-items: center; gap: 14px; flex-wrap: wrap; }

.clock {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  line-height: 1.1;
}
.clock-time {
  font-variant-numeric: tabular-nums;
  font-weight: 700;
  font-size: 18px;
  letter-spacing: 1px;
  color: var(--text);
}
.clock-date { font-size: 10.5px; color: var(--text-muted); text-transform: capitalize; }

.status-cluster { display: flex; gap: 8px; flex-wrap: wrap; }
.ws-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  font-weight: 600;
  padding: 5px 10px;
  border-radius: 999px;
  background: var(--kpi-bg);
  border: 1px solid var(--border);
  color: var(--text-muted);
  text-transform: capitalize;
}
.ws-dot {
  width: 7px; height: 7px; border-radius: 50%;
  background: #94a3b8;
  box-shadow: 0 0 0 0 rgba(148,163,184,.5);
}
.pill-open { color: #34d399; border-color: rgba(52,211,153,.35); }
.pill-open .ws-dot { background: #34d399; animation: pulse-dot 1.8s infinite; }
.pill-retry { color: #fbbf24; border-color: rgba(251,191,36,.35); }
.pill-retry .ws-dot { background: #fbbf24; animation: pulse-dot 1s infinite; }
@keyframes pulse-dot {
  0% { box-shadow: 0 0 0 0 currentColor; opacity: 1; }
  70% { box-shadow: 0 0 0 6px transparent; opacity: .85; }
  100% { box-shadow: 0 0 0 0 transparent; opacity: 1; }
}

.theme-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px; height: 38px;
  border-radius: 12px;
  border: 1px solid var(--border-strong);
  background: var(--kpi-bg);
  color: var(--text);
  cursor: pointer;
  transition: transform .18s ease, color .18s ease, border-color .18s ease, background .18s ease;
}
.theme-toggle svg { width: 18px; height: 18px; }
.theme-toggle:hover { color: var(--accent); border-color: var(--accent); transform: translateY(-1px) rotate(12deg); }

/* ============================================================
   TABS
   ============================================================ */
.tabs {
  display: flex;
  gap: 6px;
  margin: 16px 0;
  flex-wrap: wrap;
  padding: 6px;
  border-radius: 16px;
  background: var(--glass);
  border: 1px solid var(--border);
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
  width: fit-content;
  max-width: 100%;
}
.tab {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 9px 16px;
  border: 1px solid transparent;
  border-radius: 12px;
  background: transparent;
  color: var(--text-muted);
  font-size: 13px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  transition: color .18s ease, background .18s ease, box-shadow .18s ease, transform .18s ease;
}
.tab .tab-ico { width: 16px; height: 16px; opacity: .9; }
.tab:hover { color: var(--text); background: var(--row-hover); }
.tab.active {
  color: #fff;
  background: var(--accent-grad-h);
  box-shadow: 0 8px 22px rgba(56,189,248,.35);
  transform: translateY(-1px);
}
.theme-light .tab.active { box-shadow: 0 8px 20px rgba(2,132,199,.30); }

/* ============================================================
   TAB BODY / CONTROLS
   ============================================================ */
.tab-body { display: flex; flex-direction: column; gap: 14px; }

.controls {
  display: flex;
  gap: 14px;
  align-items: center;
  flex-wrap: wrap;
  font-size: 13px;
  color: var(--text-muted);
  padding: 12px 16px;
  border-radius: 14px;
  background: var(--glass);
  border: 1px solid var(--border);
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
}
.controls label { display: inline-flex; align-items: center; gap: 8px; font-weight: 500; }
.controls input[type="date"],
.controls input[type="month"],
.controls input[type="number"] {
  padding: 7px 10px;
  font-size: 13px;
  font-family: inherit;
  color: var(--text);
  background: var(--input-bg);
  border: 1px solid var(--input-border);
  border-radius: 9px;
  width: auto;
  accent-color: var(--accent);
  transition: border-color .15s ease, box-shadow .15s ease;
}
.controls input:focus {
  outline: none;
  border-color: var(--accent);
  box-shadow: 0 0 0 3px rgba(56,189,248,.20);
}

/* ============================================================
   HERO KPI STRIP
   ============================================================ */
.hero-strip {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 12px;
}
.hero-tile {
  position: relative;
  padding: 16px 18px;
  border-radius: 16px;
  background: var(--card-bg);
  border: 1px solid var(--card-border);
  box-shadow: var(--card-shadow);
  -webkit-backdrop-filter: var(--card-blur);
  backdrop-filter: var(--card-blur);
  overflow: hidden;
  transition: transform .18s ease, box-shadow .18s ease, border-color .18s ease;
}
.hero-tile::before {
  content: "";
  position: absolute;
  left: 0; top: 0; bottom: 0;
  width: 3px;
  background: var(--accent-grad);
}
.hero-tile:hover {
  transform: translateY(-3px);
  box-shadow: var(--card-shadow-hover);
  border-color: var(--card-border-hover);
}
.hero-tile:nth-child(2)::before { background: linear-gradient(180deg, #34d399, #10b981); }
.hero-tile:nth-child(3)::before { background: linear-gradient(180deg, #fbbf24, #f59e0b); }
.hero-tile:nth-child(4)::before { background: linear-gradient(180deg, #f472b6, #ec4899); }
.hero-label {
  display: block;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: .6px;
  text-transform: uppercase;
  color: var(--text-muted);
}
.hero-value {
  display: block;
  margin-top: 6px;
  font-size: 26px;
  font-weight: 800;
  line-height: 1.1;
  letter-spacing: .3px;
  color: var(--text);
  font-variant-numeric: tabular-nums;
}

.grid { display:grid; grid-template-columns: repeat(auto-fit, minmax(260px, 1fr)); gap:10px; }

.list { list-style:none; padding:0; margin:0; display:flex; flex-direction:column; gap:6px; }
.list li { display:flex; justify-content:space-between; align-items:center; font-size:13px; padding:3px 0; border-bottom:1px dashed var(--border); }
.list li:last-child { border-bottom:none; }
.name { overflow:hidden; text-overflow:ellipsis; white-space:nowrap; max-width: 70%; color: var(--text); }
.right { font-weight:700; color: var(--text); }
.muted { color: var(--text-dim); font-size:12px; }

.table-wrap { overflow:auto; border:1px solid var(--border); border-radius:10px; }
.table-wrap table { width:100%; border-collapse:collapse; font-size:12px; color: var(--text); }
.table-wrap th, .table-wrap td { padding:7px 9px; border-bottom:1px solid var(--border); text-align:left; }
.table-wrap td.num, .table-wrap th.num { text-align:right; }
.table-wrap tbody tr { transition: background .12s ease; }
.table-wrap tbody tr:hover td { background: var(--row-hover); }

.kpis { display:flex; gap:12px; flex-wrap:wrap; margin-bottom:12px; }
.kpi { background: var(--kpi-bg); border:1px solid var(--border); border-radius:12px; padding:10px 12px; min-width:84px; text-align:center; }
.kpi-label { font-size:11px; color: var(--text-muted); }
.kpi-value { font-weight:700; font-size:16px; color: var(--text); }
.single-kpi {
  font-size:34px; font-weight:800; text-align:center; padding:14px;
  background: var(--accent-grad-h);
  -webkit-background-clip: text; background-clip: text; color: transparent;
  font-variant-numeric: tabular-nums;
}

.placeholder { color: var(--text-dim); font-size:13px; padding:16px; border:1px dashed var(--border-strong); border-radius:12px; background: var(--kpi-bg); }

/* generic scrolling wrapper for up to 15 rows */
.scroll-rows-15 {
  max-height: calc(15 * var(--row-h) + var(--head-h));
  overflow: auto;
}

/* tables: keep header visible while body scrolls */
.table-wrap table {
  border-collapse: collapse;
  width: 100%;
}
.table-wrap thead th {
  position: sticky;
  top: 0;
  background: var(--table-head-bg);
  color: var(--text-muted);
  font-weight: 700;
  -webkit-backdrop-filter: blur(6px);
  backdrop-filter: blur(6px);
  z-index: 1;
}

/* optional: for <ol>/<ul> lists */
.list.scroll-rows-15 {
  max-height: calc(15 * var(--row-h));
  overflow: auto;
}


/* Desktop masonry: 3 columns; tablet: 2; mobile: 1 */
.masonry {
  column-count: 3;
  column-gap: 1rem;
}
@media (max-width: 900px) { .masonry { column-count: 2; } }
@media (max-width: 650px) { .masonry { column-count: 1; } }


/* Each card must be inline-block so it respects column flow */

/* Masonry items – MUST be block for columns to form correctly */
.masonry :deep(.stat-card) {
  display: block;                    /* <- key: block, not inline-block */
  margin: 0 0 1rem;
  break-inside: avoid-column;        /* standard */
  -webkit-column-break-inside: avoid;/* Safari/Chrome */
  -moz-column-break-inside: avoid;   /* Firefox */
  width: auto;                       /* don’t force a width that fights columns */
  max-width: none;
}


/* keep your scroll cap util working inside cards */
.scroll-rows-15 { max-height: calc(15 * var(--row-h) + var(--head-h)); overflow: auto; }

.legend-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 12px;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid var(--border);
  font-size: 12px;
  list-style: none;
  padding-left: 0;
}
.legend-wrap li { display: flex; align-items: center; gap: 6px; color: var(--text-muted); }
.swatch { width: 10px; height: 10px; border-radius: 3px; border: 1px solid var(--border-strong); }
.legend-name { white-space: nowrap; }
.legend-val { color: var(--text-dim); }

/* highlight rows */
.best  td { background: rgba(34,197,94,.16) !important; }
.worst td { background: rgba(239,68,68,.16) !important; }


.rrhh-monthly-layout {
  display: grid;
  grid-template-columns: minmax(220px, 1.1fr) minmax(240px, 1.5fr);
  gap: 10px;
}

/* stack vertically on narrower screens */
@media (max-width: 900px) {
  .rrhh-monthly-layout {
    grid-template-columns: 1fr;
  }
}

.rrhh-monthly-table {
  display: flex;
  flex-direction: column;
}

.table-header-actions {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 4px;
}

.link-button {
  border: none;
  background: none;
  padding: 0;
  font-size: 12px;
  font-weight: 600;
  color: var(--accent);
  cursor: pointer;
}

.link-button:hover {
  text-decoration: underline;
}

.clickable-row {
  cursor: pointer;
}

.clickable-row:hover td {
  background: var(--row-hover);
}

.row-selected td {
  background: rgba(56,189,248,.16);
}

.row-selected:hover td {
  background: rgba(56,189,248,.24);
}



/* card is 100% width of dashboard */
.rrhh-wide-card {
  width: 80% !important;
  margin-top: 12px;
}

/* 2-column layout inside */
.rrhh-monthly-layout {
  display: grid;
  grid-template-columns: 320px 1fr; /* left table fixed, right chart expands */
  gap: 16px;
  width: 100%;
}

/* mobile */
@media (max-width: 900px) {
  .rrhh-monthly-layout {
    grid-template-columns: 1fr;
  }
}

/* chart: stretch */
.rrhh-monthly-chart {
  width: 100%;
  min-height: 420px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.rrhh-matrix-wrap {
  max-width: 100%;
  overflow: auto;
  border: 1px solid var(--border);
  border-radius: 12px;
  background: var(--surface-solid);
}

/* ── Shared base for RRHH + Estadístico data tables ── */
.rrhh-matrix-table,
.estadistico-table {
  border-collapse: separate;
  border-spacing: 0;
  font-variant-numeric: tabular-nums;
}

/* elegant, single-hue sticky headers (no rainbow gradient) */
.rrhh-matrix-table thead th,
.estadistico-table thead th {
  position: sticky;
  top: 0;
  z-index: 2;
  background: var(--head-bg), var(--surface-solid);
  color: var(--text-muted);
  font-weight: 700;
  font-size: 10.5px;
  text-transform: uppercase;
  letter-spacing: .6px;
  border-bottom: 2px solid var(--accent);
  -webkit-backdrop-filter: blur(6px);
  backdrop-filter: blur(6px);
}
.rrhh-matrix-table thead .sticky-col,
.estadistico-table thead .sticky-col {
  z-index: 3;
  background: var(--head-bg), var(--surface-solid);
}

/* zebra + hover */
.rrhh-matrix-table tbody tr:nth-child(even) td,
.estadistico-table tbody tr:nth-child(even) td {
  background-color: var(--row-even);
}
.rrhh-matrix-table tbody tr:hover td,
.estadistico-table tbody tr:hover td {
  background-color: var(--row-hover);
}

/* frozen first column */
.rrhh-matrix-table .sticky-col,
.estadistico-table .sticky-col {
  position: sticky;
  left: 0;
  z-index: 1;
  background: var(--surface-solid);
  box-shadow: 10px 0 16px -12px rgba(2, 6, 23, .45);
}
.rrhh-matrix-table tbody tr:nth-child(even) .sticky-col,
.estadistico-table tbody tr:nth-child(even) .sticky-col {
  background: var(--surface-solid);
}
.rrhh-matrix-table tbody tr:hover .sticky-col,
.estadistico-table tbody tr:hover .sticky-col {
  background: var(--surface-solid);
  color: var(--accent);
}

/* ── RRHH matrix: a clean heatmap; may scroll horizontally ── */
.rrhh-matrix-table {
  width: max-content;
  min-width: 100%;
  font-size: 12px;
}
.rrhh-matrix-table th,
.rrhh-matrix-table td {
  padding: 7px 9px;
  border-bottom: 1px solid var(--border);
  white-space: nowrap;
  color: var(--text);
  transition: background .12s ease, color .12s ease;
}
.rrhh-matrix-table .num { text-align: center; min-width: 34px; }
.rrhh-matrix-table .day-cell { border-radius: 6px; }

/* ── Estadístico tables: numbers always on a single line; client column kept slim ── */
.estadistico-table {
  width: max-content;
  min-width: 100%;
  font-size: 11px;
}
.estadistico-table th,
.estadistico-table td {
  padding: 5px 9px;
  border-bottom: 1px solid var(--border);
  color: var(--text);
  text-align: center;
  white-space: nowrap;          /* numbers display freely, never wrap */
  transition: background .12s ease, color .12s ease;
}
/* slim client column; long names wrap inside it instead of widening the table */
.estadistico-table .sticky-col {
  width: 132px;
  max-width: 132px;
  text-align: left;
  font-weight: 600;
  white-space: normal;
  overflow-wrap: anywhere;
  line-height: 1.2;
}

.estadistico-stack {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.estadistico-table-wrap {
  overflow: auto;
  border: 1px solid var(--border);
  border-radius: 12px;
  background: var(--surface-solid);
}

.estadistico-table .total-label {
  color: var(--accent);
  font-weight: 800;
  letter-spacing: .3px;
}

/* serious, uniform clerk names with a small color cue that maps to the line chart */
.clerk-name {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  font-weight: 600;
  color: var(--text);
  letter-spacing: .2px;
}
.clerk-dot {
  width: 8px;
  height: 8px;
  border-radius: 2px;
  flex: 0 0 auto;
  box-shadow: 0 0 0 2px var(--surface-solid), 0 0 0 3px var(--border);
}

.day-cell,
.total-cell {
  text-align: center;
}

/* accent the row/column totals */
.total-cell {
  font-weight: 800;
  color: var(--accent);
  background: linear-gradient(180deg, rgba(56, 189, 248, .14), rgba(99, 102, 241, .14)) !important;
}
.theme-light .total-cell {
  background: linear-gradient(180deg, rgba(2, 132, 199, .10), rgba(99, 102, 241, .10)) !important;
}

.rrhh-monthly-chart :deep(.echarts) {
  width: 100% !important;
  height: 320px !important;
}

/* ── Publicidad (Google Ads) ── */
.ads-controls { align-items: center; }
.ads-presets { display: inline-flex; gap: 6px; margin-left: auto; flex-wrap: wrap; }
.ads-preset {
  font-family: inherit;
  font-size: 12px;
  font-weight: 600;
  padding: 6px 12px;
  border-radius: 999px;
  border: 1px solid var(--border-strong);
  background: var(--kpi-bg);
  color: var(--text-muted);
  cursor: pointer;
  transition: color .15s ease, background .15s ease, border-color .15s ease;
}
.ads-preset:hover { color: var(--text); border-color: var(--accent); }
.ads-preset.active {
  color: #fff;
  background: var(--accent-grad-h);
  border-color: transparent;
}

.ads-group { display: flex; flex-direction: column; gap: 14px; }
.ads-group + .ads-group { margin-top: 6px; }
.ads-group-title {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 6px 0 2px;
  font-size: 15px;
  font-weight: 700;
  letter-spacing: .3px;
  color: var(--text);
}
.ads-group-bar {
  width: 6px;
  height: 20px;
  border-radius: 999px;
  background: linear-gradient(180deg, #38bdf8, #6366f1);
}
.ads-group-bar.montacargas { background: linear-gradient(180deg, #f59e0b, #ef4444); }

.ads-services-table { max-height: calc(15 * var(--row-h) + var(--head-h)); }
.ads-type-chip {
  display: inline-block;
  font-size: 11px;
  font-weight: 700;
  padding: 2px 9px;
  border-radius: 999px;
  border: 1px solid transparent;
}
.ads-type-chip.remo { color: #0284c7; background: rgba(2, 132, 199, .12); border-color: rgba(2, 132, 199, .30); }
.ads-type-chip.mont { color: #d97706; background: rgba(217, 119, 6, .12); border-color: rgba(217, 119, 6, .30); }
.theme-dark .ads-type-chip.remo { color: #7dd3fc; }
.theme-dark .ads-type-chip.mont { color: #fbbf24; }

.ads-open-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  font-weight: 600;
  text-decoration: none;
  padding: 4px 10px;
  border-radius: 8px;
  color: #fff;
  background: var(--accent-grad-h);
  border: 1px solid transparent;
  transition: transform .15s ease, box-shadow .15s ease, opacity .15s ease;
}
.ads-open-btn:hover { transform: translateY(-1px); box-shadow: 0 6px 16px -8px var(--accent); opacity: .95; }
.ads-open-btn svg { width: 13px; height: 13px; }

/* ============================================================
   SUB-TABS (sections inside a tab)
   ============================================================ */
.subtabs {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  padding: 5px;
  border-radius: 14px;
  background: var(--glass);
  border: 1px solid var(--border);
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
  width: fit-content;
  max-width: 100%;
}
.subtab {
  padding: 7px 14px;
  border: 1px solid transparent;
  border-radius: 10px;
  background: transparent;
  color: var(--text-muted);
  font-family: inherit;
  font-size: 12.5px;
  font-weight: 600;
  cursor: pointer;
  transition: color .18s ease, background .18s ease, box-shadow .18s ease;
}
.subtab:hover { color: var(--text); background: var(--row-hover); }
.subtab.active {
  color: #fff;
  background: var(--accent-grad-h);
  box-shadow: 0 6px 16px -8px var(--accent);
}

/* ============================================================
   UNIDADES: per-unit totals board (category columns)
   ============================================================ */
.controls .unit-sort {
  padding: 7px 10px;
  font-size: 13px;
  font-family: inherit;
  color: var(--text);
  background: var(--input-bg);
  border: 1px solid var(--input-border);
  border-radius: 9px;
  font-weight: 600;
  cursor: pointer;
}
.controls .unit-sort:focus {
  outline: none;
  border-color: var(--accent);
  box-shadow: 0 0 0 3px rgba(56,189,248,.20);
}
.controls .unit-toggle { gap: 6px; cursor: pointer; }
.controls .unit-toggle input { accent-color: var(--accent); cursor: pointer; }

/* Category selector pills */
.unit-pills {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.unit-pill {
  --col-accent: var(--accent);
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 15px;
  border-radius: 999px;
  border: 1px solid var(--border-strong);
  background: var(--kpi-bg);
  color: var(--text-muted);
  font-family: inherit;
  font-size: 12.5px;
  font-weight: 600;
  cursor: pointer;
  transition: color .18s ease, background .18s ease, border-color .18s ease, box-shadow .18s ease;
}
.unit-pill--ab { --col-accent: #38bdf8; }
.unit-pill--cd { --col-accent: #34d399; }
.unit-pill--montacargas { --col-accent: #f59e0b; }
.unit-pill--otro { --col-accent: #a78bfa; }

.unit-pill:hover { color: var(--text); border-color: var(--col-accent); }
.unit-pill.active {
  color: var(--text);
  border-color: var(--col-accent);
  background: color-mix(in srgb, var(--col-accent) 16%, transparent);
  box-shadow: 0 6px 16px -10px var(--col-accent);
}
.unit-pill__dot {
  width: 9px; height: 9px;
  border-radius: 999px;
  background: var(--col-accent);
  flex: 0 0 auto;
}
.unit-pill__count {
  min-width: 22px;
  text-align: center;
  padding: 1px 7px;
  border-radius: 999px;
  background: var(--col-accent);
  color: #06101f;
  font-size: 11px;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
}

/* Card grid: pack as many cards per row as the viewport allows */
.unit-grid {
  --col-accent: var(--accent);
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(222px, 1fr));
  gap: 10px;
  align-items: start;
}
.unit-grid--ab { --col-accent: #38bdf8; }
.unit-grid--cd { --col-accent: #34d399; }
.unit-grid--montacargas { --col-accent: #f59e0b; }
.unit-grid--otro { --col-accent: #a78bfa; }

.unit-grid__empty {
  grid-column: 1 / -1;
  padding: 26px 0;
  text-align: center;
  color: var(--text-dim);
  font-size: 12.5px;
  border: 1px dashed var(--border-strong);
  border-radius: 12px;
}

.unit-stat-card {
  display: grid;
  gap: 8px;
  padding: 9px 11px;
  border-radius: 11px;
  border: 1px solid var(--border);
  border-left: 4px solid var(--col-accent);
  background: var(--kpi-bg);
  transition: transform .18s ease, box-shadow .18s ease, border-color .18s ease;
}
.unit-stat-card:hover {
  transform: translateY(-1px);
  box-shadow: var(--card-shadow);
  border-color: var(--border-strong);
  border-left-color: var(--col-accent);
}

.unit-stat-card__top {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
}
.unit-stat-card__id {
  font-size: 15px;
  font-weight: 800;
  letter-spacing: .02em;
  color: var(--text);
  font-variant-numeric: tabular-nums;
}
.unit-stat-card__cat {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: .5px;
  text-transform: uppercase;
  color: var(--text-muted);
  padding: 2px 7px;
  border-radius: 999px;
  border: 1px solid var(--border-strong);
}

/* Single row, never clipped and never wrapped: each metric sizes to its own
   content and the grid track below is wide enough for the widest figures. */
.unit-stat-card__metrics {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  gap: 10px;
}
.unit-metric {
  display: flex;
  flex-direction: column;
  gap: 1px;
  flex: 0 0 auto;
}
.unit-metric__label {
  font-size: 9.5px;
  font-weight: 600;
  letter-spacing: .5px;
  text-transform: uppercase;
  color: var(--text-dim);
}
.unit-metric__value {
  font-size: 13px;
  font-weight: 700;
  color: var(--text);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.unit-stat-card__last {
  display: flex;
  align-items: center;
  gap: 5px;
  padding-top: 6px;
  border-top: 1px solid var(--border);
  font-size: 10.5px;
  line-height: 1.25;
  color: var(--text-dim);
}
.unit-stat-card__last svg { flex: 0 0 auto; }
.unit-stat-card__last--alert { color: #f87171; font-weight: 700; }
.theme-light .unit-stat-card__last--alert { color: #dc2626; }
.unit-stat-card:has(.unit-stat-card__last--alert) { border-left-color: #ef4444; }

</style>
